/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getProductGuideMembershipEditor = /* GraphQL */ `query GetProductGuideMembershipEditor(
  $input: ProductGuideMembershipEditorInput!
) {
  getProductGuideMembershipEditor(input: $input) {
    code
    message
    retryable
    updatedAt
    membershipIds
    projectionStatus
    payload
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProductGuideMembershipEditorQueryVariables,
  APITypes.GetProductGuideMembershipEditorQuery
>;
export const getCategoryGuideMembershipEditor = /* GraphQL */ `query GetCategoryGuideMembershipEditor(
  $input: CategoryGuideMembershipEditorInput!
) {
  getCategoryGuideMembershipEditor(input: $input) {
    code
    message
    retryable
    updatedAt
    membershipIds
    projectionStatus
    payload
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCategoryGuideMembershipEditorQueryVariables,
  APITypes.GetCategoryGuideMembershipEditorQuery
>;
export const knowledgeBaseRows = /* GraphQL */ `query KnowledgeBaseRows(
  $objectType: String!
  $objectID: ID!
  $organizationID: ID!
) {
  knowledgeBaseRows(
    objectType: $objectType
    objectID: $objectID
    organizationID: $organizationID
  ) {
    id
    chunkIndex
    chunkText
    metadata
    skus
    productAttributes
    __typename
  }
}
` as GeneratedQuery<
  APITypes.KnowledgeBaseRowsQueryVariables,
  APITypes.KnowledgeBaseRowsQuery
>;
export const indexedTextPreview = /* GraphQL */ `query IndexedTextPreview(
  $objectType: String!
  $organizationID: ID!
  $objectID: ID!
) {
  indexedTextPreview(
    objectType: $objectType
    organizationID: $organizationID
    objectID: $objectID
  ) {
    text
    __typename
  }
}
` as GeneratedQuery<
  APITypes.IndexedTextPreviewQueryVariables,
  APITypes.IndexedTextPreviewQuery
>;
export const userInfo = /* GraphQL */ `query UserInfo {
  userInfo {
    Cognito {
      Username
      UserCreateDate
      UserLastModifiedDate
      Enabled
      UserStatus
      PreferredMfaSetting
      UserMFASettingList
      __typename
    }
    UserAttributes {
      Name
      Value
      __typename
    }
    Internal {
      id
      createdAt
      updatedAt
      name
      biography
      profileImage
      email
      background
      headline
      title
      enableAdminAgent
      __typename
    }
    Organizations {
      id
      name
      createdAt
      updatedAt
      stripePublicKey
      stripeSecretKey
      googleApiConfig
      googleApiSyncInfo
      cognitoUserPoolID
      cognitoWebClientID
      cognitoIdentityPoolID
      signUpFields
      signUpRequiredFields
      appsyncGraphqlID
      appsyncGraphqlKey
      appsyncGraphqlUrl
      deployedAt
      deployStatus
      accessGroups
      enableDiscussionGroups
      enableAI
      defaultRoles
      enableMeetings
      enableHubs
      enableGeo
      enableCompetitiveContentScore
      clientAILanguageModel
      contentGenerationModel
      clientAIStatus
      crawlConfigs
      internalIpRanges
      usePostHnswFilter
      exportFullConversations
      syncConfigs
      searchGuidance
      status
      deletedAt
      deletedBy
      purgeScheduledAt
      purgeStatus
      purgeSteps
      purgeError
      clonedFromEnv
      clonedAt
      __typename
    }
    UserOrganizations {
      id
      userID
      organizationID
      name
      superUser
      roles
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<APITypes.UserInfoQueryVariables, APITypes.UserInfoQuery>;
export const customerInfo = /* GraphQL */ `query CustomerInfo($organizationID: String, $portalID: String) {
  customerInfo(organizationID: $organizationID, portalID: $portalID) {
    Cognito {
      Username
      UserCreateDate
      UserLastModifiedDate
      Enabled
      UserStatus
      PreferredMfaSetting
      UserMFASettingList
      __typename
    }
    UserAttributes {
      Name
      Value
      __typename
    }
    Internal {
      id
      organizationID
      createdAt
      updatedAt
      name
      phoneNumber
      biography
      profileImage
      email
      temporaryPassword
      background
      headline
      internalNotes
      title
      hubID
      stripeCustomerID
      activeMembershipCount
      trialMembershipCount
      overdueMembershipCount
      expiredMembershipCount
      lastPaymentAt
      nextPaymentAt
      text1
      text2
      text3
      text4
      text5
      status
      __typename
    }
    Members {
      id
      organizationID
      customerID
      portalID
      membershipID
      name
      status
      createdAt
      updatedAt
      expiresOn
      lastPaymentAt
      nextPaymentAt
      failedPaymentAttempts
      stripeSessionID
      stripePaymentIntentID
      stripeSubscriptionID
      stripeCustomerID
      stripeInvoiceID
      stripeExpiresAt
      __typename
    }
    Access {
      groups
      purchasedCourses
      purchasedMicrocasts
      purchasedPrograms
      __typename
    }
    CourseProgresses {
      id
      organizationID
      customerID
      courseID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      lessonProgress
      lessonsCompleted
      quizResults
      notes
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      scormData
      tracking
      __typename
    }
    DocumentProgresses {
      id
      organizationID
      customerID
      documentKey
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      notes
      status
      viewCount
      history
      includeInMyDocuments
      __typename
    }
    MeetingRegistrations {
      id
      organizationID
      portalID
      customerID
      meetingID
      name
      status
      createdAt
      updatedAt
      notes
      history
      __typename
    }
    MicrocastProgresses {
      id
      organizationID
      customerID
      microcastID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      notes
      scormData
      lastPosition
      maxPosition
      tracking
      __typename
    }
    ProgramProgresses {
      id
      organizationID
      customerID
      programID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      sectionProgress
      lessonsCompleted
      quizResults
      notes
      courseItems
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CustomerInfoQueryVariables,
  APITypes.CustomerInfoQuery
>;
export const refreshCustomerStats = /* GraphQL */ `query RefreshCustomerStats($organizationID: String, $customerID: String) {
  refreshCustomerStats(
    organizationID: $organizationID
    customerID: $customerID
  ) {
    id
    organizationID
    createdAt
    updatedAt
    name
    phoneNumber
    biography
    profileImage
    email
    temporaryPassword
    background
    headline
    internalNotes
    title
    hubID
    stripeCustomerID
    activeMembershipCount
    trialMembershipCount
    overdueMembershipCount
    expiredMembershipCount
    lastPaymentAt
    nextPaymentAt
    text1
    text2
    text3
    text4
    text5
    status
    learningBoards {
      nextToken
      __typename
    }
    members {
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RefreshCustomerStatsQueryVariables,
  APITypes.RefreshCustomerStatsQuery
>;
export const learningBoard = /* GraphQL */ `query LearningBoard($organizationID: String, $portalID: String) {
  learningBoard(organizationID: $organizationID, portalID: $portalID) {
    id
    organizationID
    portalID
    customerID
    createdAt
    updatedAt
    name
    status
    sections
    learningBoardViewedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LearningBoardQueryVariables,
  APITypes.LearningBoardQuery
>;
export const createProgramProgressQuery = /* GraphQL */ `query CreateProgramProgressQuery($programID: String, $organizationID: String) {
  createProgramProgressQuery(
    programID: $programID
    organizationID: $organizationID
  ) {
    statusCode
    body
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CreateProgramProgressQueryQueryVariables,
  APITypes.CreateProgramProgressQueryQuery
>;
export const createMicrocastProgressQuery = /* GraphQL */ `query CreateMicrocastProgressQuery(
  $microcastID: String
  $organizationID: String
) {
  createMicrocastProgressQuery(
    microcastID: $microcastID
    organizationID: $organizationID
  ) {
    statusCode
    body
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CreateMicrocastProgressQueryQueryVariables,
  APITypes.CreateMicrocastProgressQueryQuery
>;
export const sendTestEmail = /* GraphQL */ `query SendTestEmail(
  $organizationID: String
  $portalID: String
  $customerID: String
  $subject: String
  $body: String
  $fromEmail: String
  $toEmail: String
  $bccEmails: String
) {
  sendTestEmail(
    organizationID: $organizationID
    portalID: $portalID
    customerID: $customerID
    subject: $subject
    body: $body
    fromEmail: $fromEmail
    toEmail: $toEmail
    bccEmails: $bccEmails
  ) {
    subject
    body
    result
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SendTestEmailQueryVariables,
  APITypes.SendTestEmailQuery
>;
export const checkStatus = /* GraphQL */ `query CheckStatus($organizationID: String!, $items: [StatusItem]!) {
  checkStatus(organizationID: $organizationID, items: $items) {
    type
    id
    asset {
      id
      organizationID
      createdAt
      updatedAt
      externalID
      repositoryID
      name
      key
      description
      type
      tags
      mimeType
      derivativeStatus
      transcribeStatus
      status
      access
      dominantColor
      length
      transcript
      scormManifest
      useHls
      hlsGenerated
      __typename
    }
    course {
      id
      organizationID
      slug
      manualSlug
      format
      libraries
      createdAt
      updatedAt
      externalID
      name
      active
      headline
      description
      objectives
      tags
      keywords
      level
      length
      courseImage
      courseImageThumbnail
      promoVideo
      posterImage
      sharePassword
      audience
      requiredSkills
      gated
      confirmationMessage
      welcomeMessage
      congratulatoryMessage
      startDate
      expiryDate
      searchable
      sections
      reviews
      currency
      discountPercent
      avgRating
      reviewsCount
      courseLessons
      price
      sellPrice
      certification
      companyName
      enrollmentCount
      lessonCount
      faqs
      instructors
      searchInstructors
      ctaUrl
      ctaLabel
      ctaNewWindow
      accessConfiguration
      accessGroups
      excludeFromAllCourses
      portalKicker
      prerequisiteMessage
      prerequisiteCertificates
      richText1
      richText2
      richText3
      richText4
      richText5
      richText6
      richText7
      richText8
      richText9
      richText10
      enrollmentOffered
      aiWizardContent
      discussionTopic
      doNotIndex
      doNotReference
      ogImage
      enableAutoplay
      __typename
    }
    organization {
      id
      name
      createdAt
      updatedAt
      stripePublicKey
      stripeSecretKey
      googleApiConfig
      googleApiSyncInfo
      cognitoUserPoolID
      cognitoWebClientID
      cognitoIdentityPoolID
      signUpFields
      signUpRequiredFields
      appsyncGraphqlID
      appsyncGraphqlKey
      appsyncGraphqlUrl
      deployedAt
      deployStatus
      accessGroups
      enableDiscussionGroups
      enableAI
      defaultRoles
      enableMeetings
      enableHubs
      enableGeo
      enableCompetitiveContentScore
      clientAILanguageModel
      contentGenerationModel
      clientAIStatus
      crawlConfigs
      internalIpRanges
      usePostHnswFilter
      exportFullConversations
      syncConfigs
      searchGuidance
      status
      deletedAt
      deletedBy
      purgeScheduledAt
      purgeStatus
      purgeSteps
      purgeError
      clonedFromEnv
      clonedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CheckStatusQueryVariables,
  APITypes.CheckStatusQuery
>;
export const batchGetModel = /* GraphQL */ `query BatchGetModel($organizationID: ID!, $modelName: String!, $ids: [ID]!) {
  batchGetModel(
    organizationID: $organizationID
    modelName: $modelName
    ids: $ids
  ) {
    organization {
      id
      name
      createdAt
      updatedAt
      stripePublicKey
      stripeSecretKey
      googleApiConfig
      googleApiSyncInfo
      cognitoUserPoolID
      cognitoWebClientID
      cognitoIdentityPoolID
      signUpFields
      signUpRequiredFields
      appsyncGraphqlID
      appsyncGraphqlKey
      appsyncGraphqlUrl
      deployedAt
      deployStatus
      accessGroups
      enableDiscussionGroups
      enableAI
      defaultRoles
      enableMeetings
      enableHubs
      enableGeo
      enableCompetitiveContentScore
      clientAILanguageModel
      contentGenerationModel
      clientAIStatus
      crawlConfigs
      internalIpRanges
      usePostHnswFilter
      exportFullConversations
      syncConfigs
      searchGuidance
      status
      deletedAt
      deletedBy
      purgeScheduledAt
      purgeStatus
      purgeSteps
      purgeError
      clonedFromEnv
      clonedAt
      __typename
    }
    portal {
      id
      organizationID
      defaultLibraryID
      libraries
      libraryShares
      createdAt
      updatedAt
      name
      active
      publicName
      publicDomain
      sslDomain
      description
      type
      allowSearch
      enableInstructors
      requireSignature
      logoImage
      faviconImage
      ogImage
      categories
      pageDefaults
      pageRules
      componentConfigs
      termsOfService
      cardShowPrice
      publicCardShowActionButton
      publicCardButtonLabel
      publicCardAction
      publicLandingPageButtonLabel
      membershipCardShowActionButton
      membershipCardWithAccessButtonLabel
      membershipCardWithAccessAction
      membershipCardNoAccessButtonLabel
      membershipCardNoAccessAction
      membershipLandingPageWithAccessButtonLabel
      membershipLandingPageNoAccessButtonLabel
      membershipLandingPageNoAccessMembershipAction
      commerceCardShowActionButton
      commerceCardNoAccessButtonLabel
      commerceCardNoAccessAction
      commerceCardWithAccessButtonLabel
      commerceCardWithAccessAction
      commerceLandingPageWithAccessButtonLabel
      commerceLandingPageNoAccessButtonLabel
      commerceLandingPageNoAccessAction
      primaryMembershipID
      membershipOfferPageID
      noAccessImage
      learningBoardGroupNames
      stylesheet
      tokens
      supportedLocales
      defaultCheckoutConfirmationMessage
      courseCardShowImage
      courseCardShowTitle
      courseCardShowInstructor
      courseCardShowDesc
      courseCardShowInfoBar
      courseCardShowActionButton
      courseCardShowLessonCount
      showCertification
      orderConfirmationEmailID
      newCustomerMembershipID
      showLearningBoard
      showUserNameInLearningBoard
      trackDeskTenantId
      cloudfrontDistributionID
      cloudfrontDistributionDomain
      deployedAt
      deployStatus
      googleAnalyticsTagID
      programLandingWithAccessCourseAction
      footerScripts
      repositoryOriginAccessIdentityID
      clientAIAnswerLength
      clientAIFeedbackButtons
      clientAIPromptPlaceholder
      clientAISuggestedPrompts
      clientAIPersistentPrompts
      clientAIPromptTemplate
      clientAIStartingMessage
      clientAIInlineReferences
      clientAISuggestRefinements
      clientAIAdditionalInstructions
      clientAIConfig
      learningBoardConfig
      addToCartEnabled
      productCardConfig
      aiSearchConfig
      clientAIBaseUrl
      showQuizResultsTab
      status
      purgeStatus
      purgeSteps
      purgeError
      __typename
    }
    course {
      id
      organizationID
      slug
      manualSlug
      format
      libraries
      createdAt
      updatedAt
      externalID
      name
      active
      headline
      description
      objectives
      tags
      keywords
      level
      length
      courseImage
      courseImageThumbnail
      promoVideo
      posterImage
      sharePassword
      audience
      requiredSkills
      gated
      confirmationMessage
      welcomeMessage
      congratulatoryMessage
      startDate
      expiryDate
      searchable
      sections
      reviews
      currency
      discountPercent
      avgRating
      reviewsCount
      courseLessons
      price
      sellPrice
      certification
      companyName
      enrollmentCount
      lessonCount
      faqs
      instructors
      searchInstructors
      ctaUrl
      ctaLabel
      ctaNewWindow
      accessConfiguration
      accessGroups
      excludeFromAllCourses
      portalKicker
      prerequisiteMessage
      prerequisiteCertificates
      richText1
      richText2
      richText3
      richText4
      richText5
      richText6
      richText7
      richText8
      richText9
      richText10
      enrollmentOffered
      aiWizardContent
      discussionTopic
      doNotIndex
      doNotReference
      ogImage
      enableAutoplay
      __typename
    }
    customer {
      id
      organizationID
      createdAt
      updatedAt
      name
      phoneNumber
      biography
      profileImage
      email
      temporaryPassword
      background
      headline
      internalNotes
      title
      hubID
      stripeCustomerID
      activeMembershipCount
      trialMembershipCount
      overdueMembershipCount
      expiredMembershipCount
      lastPaymentAt
      nextPaymentAt
      text1
      text2
      text3
      text4
      text5
      status
      __typename
    }
    document {
      id
      organizationID
      slug
      manualSlug
      libraries
      createdAt
      updatedAt
      name
      publishedAt
      active
      headline
      description
      image
      asset
      content
      tags
      keywords
      level
      instructors
      searchInstructors
      searchable
      ctaUrl
      ctaLabel
      ctaNewWindow
      excludeFromAllCourses
      accessConfiguration
      accessGroups
      portalKicker
      richText1
      richText2
      richText3
      richText4
      richText5
      richText6
      richText7
      richText8
      richText9
      richText10
      discussionTopic
      ogImage
      doNotIndex
      doNotReference
      __typename
    }
    program {
      id
      organizationID
      slug
      manualSlug
      libraries
      createdAt
      updatedAt
      externalID
      name
      headline
      description
      objectives
      tags
      keywords
      level
      length
      sharePassword
      audience
      searchable
      gated
      requiredSkills
      startDate
      expiryDate
      confirmationMessage
      welcomeMessage
      congratulatoryMessage
      lessons
      enrollmentCount
      price
      sellPrice
      instructors
      reviews
      faqs
      currency
      discountPercent
      companyName
      certification
      active
      ctaUrl
      ctaLabel
      ctaNewWindow
      sections
      lessonCount
      courseCount
      programImage
      searchInstructors
      accessGroups
      excludeFromAllCourses
      courseItems
      microcastItems
      richText1
      richText2
      richText3
      richText4
      richText5
      richText6
      richText7
      richText8
      richText9
      richText10
      discussionTopic
      ogImage
      __typename
    }
    microcast {
      id
      organizationID
      slug
      manualSlug
      format
      libraries
      createdAt
      updatedAt
      name
      active
      headline
      description
      microcastImage
      useAsPoster
      microcastAsset
      scormAsset
      posterImage
      content
      tags
      keywords
      level
      instructors
      searchInstructors
      searchable
      ctaUrl
      ctaLabel
      ctaNewWindow
      excludeFromAllCourses
      accessConfiguration
      accessGroups
      portalKicker
      richText1
      richText2
      richText3
      richText4
      richText5
      richText6
      richText7
      richText8
      richText9
      richText10
      discussionTopic
      disableSeekAhead
      ogImage
      doNotIndex
      doNotReference
      __typename
    }
    asset {
      id
      organizationID
      createdAt
      updatedAt
      externalID
      repositoryID
      name
      key
      description
      type
      tags
      mimeType
      derivativeStatus
      transcribeStatus
      status
      access
      dominantColor
      length
      transcript
      scormManifest
      useHls
      hlsGenerated
      __typename
    }
    instructor {
      id
      organizationID
      slug
      userID
      createdAt
      updatedAt
      name
      title
      byline
      aiVisibilityAuthority
      bylineRole
      sortOrder
      biography
      profileImage
      email
      linkedInUrl
      twitterUrl
      facebookUrl
      instagramUrl
      youtubeUrl
      shopifyBioArticleId
      shopifyBioUrl
      __typename
    }
    repository {
      id
      organizationID
      createdAt
      updatedAt
      name
      description
      bucket
      cdnPath
      status
      cloudfrontDistributionDomain
      cloudfrontDistributionID
      cloudfrontOriginAccessIdentity
      deployedAt
      deployStatus
      signingKeyID
      __typename
    }
    library {
      id
      organizationID
      createdAt
      updatedAt
      name
      description
      status
      __typename
    }
    product {
      id
      organizationID
      syncConfigID
      handle
      name
      bodyHtml
      vendor
      productType
      imageSrc
      url
      tags
      status
      optionTypes
      productData
      catalogCategorization
      attributes
      productSheet
      externalIDs
      variants
      relatedGuideIds
      createdAt
      updatedAt
      __typename
    }
    ecommerceCategory {
      id
      organizationID
      syncConfigID
      handle
      name
      descriptionHtml
      imageUrl
      productCount
      relatedGuideIds
      categoryData
      createdAt
      updatedAt
      __typename
    }
    webPage {
      id
      organizationID
      crawlID
      url
      name
      description
      pageMarkdown
      screenshotKey
      pageData
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.BatchGetModelQueryVariables,
  APITypes.BatchGetModelQuery
>;
export const itemProgressSearch = /* GraphQL */ `query ItemProgressSearch($input: ItemProgressSearchInput!) {
  itemProgressSearch(input: $input) {
    items {
      id
      organizationID
      customerID
      courseID
      documentID
      programID
      meetingID
      microcastID
      itemType
      createdAt
      updatedAt
      progress
      quizResults
      startedDate
      completeDate
      lastActiveDate
      certifications
      completedCertifications
      certificates
      hasCertification
      certificateStatus
      certificateScore
      certificateAwardedAt
      tracking
      __typename
    }
    nextToken
    total
    aggregates {
      totalRows
      completedCount
      inProgressCount
      notStartedCount
      averageProgress
      certifiedCount
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ItemProgressSearchQueryVariables,
  APITypes.ItemProgressSearchQuery
>;
export const getCustomersWithProgress = /* GraphQL */ `query GetCustomersWithProgress(
  $itemType: String
  $itemKey: ID
  $customerIDs: [ID]
  $organizationID: ID
) {
  getCustomersWithProgress(
    itemType: $itemType
    itemKey: $itemKey
    customerIDs: $customerIDs
    organizationID: $organizationID
  ) {
    statusCode
    body
    message
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCustomersWithProgressQueryVariables,
  APITypes.GetCustomersWithProgressQuery
>;
export const assistantStartGenerateField = /* GraphQL */ `query AssistantStartGenerateField(
  $organizationID: String!
  $itemType: String
  $itemKey: String
  $prompt: String
) {
  assistantStartGenerateField(
    organizationID: $organizationID
    itemType: $itemType
    itemKey: $itemKey
    prompt: $prompt
  ) {
    statusCode
    body
    message
    threadID
    runID
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AssistantStartGenerateFieldQueryVariables,
  APITypes.AssistantStartGenerateFieldQuery
>;
export const assistantGetCourseTranscripts = /* GraphQL */ `query AssistantGetCourseTranscripts($organizationID: String!, $id: String) {
  assistantGetCourseTranscripts(organizationID: $organizationID, id: $id) {
    statusCode
    body
    message
    threadID
    runID
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AssistantGetCourseTranscriptsQueryVariables,
  APITypes.AssistantGetCourseTranscriptsQuery
>;
export const assistantGetGenerateFieldResponse = /* GraphQL */ `query AssistantGetGenerateFieldResponse($threadID: String!, $runID: String) {
  assistantGetGenerateFieldResponse(threadID: $threadID, runID: $runID) {
    statusCode
    body
    message
    threadID
    runID
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AssistantGetGenerateFieldResponseQueryVariables,
  APITypes.AssistantGetGenerateFieldResponseQuery
>;
export const getMeetingRegistrationForCustomer = /* GraphQL */ `query GetMeetingRegistrationForCustomer(
  $organizationID: ID!
  $portalID: ID!
  $meetingKey: ID!
) {
  getMeetingRegistrationForCustomer(
    organizationID: $organizationID
    portalID: $portalID
    meetingKey: $meetingKey
  ) {
    Meeting {
      id
      organizationID
      slug
      libraries
      portalID
      meetingType
      status
      createdAt
      createdByID
      updatedAt
      name
      headline
      description
      content
      instructors
      searchInstructors
      transcript
      image
      recordingID
      recordingMediaPipelineID
      preStartOpenDuration
      startsAt
      postStartGraceDuration
      plannedDuration
      actualDuration
      preMeetingMessage
      postMeetingMessage
      mediaRegion
      registrationRequired
      registerBy
      restrictByAccessGroup
      accessGroups
      restrictByCustomer
      customers
      registrationCount
      registrationMax
      portalKicker
      attendees
      __typename
    }
    Registration {
      id
      organizationID
      portalID
      customerID
      meetingID
      name
      status
      createdAt
      updatedAt
      notes
      history
      __typename
    }
    CurrentAttendee {
      AttendeeId
      ExternalUserId
      JoinToken
      __typename
    }
    Attendees {
      AttendeeId
      ExternalUserId
      JoinToken
      __typename
    }
    statusCode
    message
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMeetingRegistrationForCustomerQueryVariables,
  APITypes.GetMeetingRegistrationForCustomerQuery
>;
export const getMeetingAttendeeInfo = /* GraphQL */ `query GetMeetingAttendeeInfo(
  $organizationID: ID!
  $portalID: ID!
  $meetingKey: ID!
  $attendeeID: ID!
) {
  getMeetingAttendeeInfo(
    organizationID: $organizationID
    portalID: $portalID
    meetingKey: $meetingKey
    attendeeID: $attendeeID
  ) {
    id
    name
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMeetingAttendeeInfoQueryVariables,
  APITypes.GetMeetingAttendeeInfoQuery
>;
export const getGoogleSyncConfig = /* GraphQL */ `query GetGoogleSyncConfig($organizationID: String!) {
  getGoogleSyncConfig(organizationID: $organizationID) {
    statusCode
    config
    message
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetGoogleSyncConfigQueryVariables,
  APITypes.GetGoogleSyncConfigQuery
>;
export const getAllAISessions = /* GraphQL */ `query GetAllAISessions($organizationID: String!) {
  getAllAISessions(organizationID: $organizationID) {
    statusCode
    message
    sessions
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAllAISessionsQueryVariables,
  APITypes.GetAllAISessionsQuery
>;
export const getAISession = /* GraphQL */ `query GetAISession($organizationID: String!, $sessionId: String!) {
  getAISession(organizationID: $organizationID, sessionId: $sessionId) {
    statusCode
    message
    session
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAISessionQueryVariables,
  APITypes.GetAISessionQuery
>;
export const runQuery = /* GraphQL */ `query RunQuery($organizationID: String!, $queryName: String!, $args: AWSJSON) {
  runQuery(
    organizationID: $organizationID
    queryName: $queryName
    args: $args
  ) {
    statusCode
    message
    results
    __typename
  }
}
` as GeneratedQuery<APITypes.RunQueryQueryVariables, APITypes.RunQueryQuery>;
export const getCrawlStatus = /* GraphQL */ `query GetCrawlStatus($organizationID: ID!, $crawlID: ID!) {
  getCrawlStatus(organizationID: $organizationID, crawlID: $crawlID) {
    statusCode
    organization {
      id
      name
      createdAt
      updatedAt
      stripePublicKey
      stripeSecretKey
      googleApiConfig
      googleApiSyncInfo
      cognitoUserPoolID
      cognitoWebClientID
      cognitoIdentityPoolID
      signUpFields
      signUpRequiredFields
      appsyncGraphqlID
      appsyncGraphqlKey
      appsyncGraphqlUrl
      deployedAt
      deployStatus
      accessGroups
      enableDiscussionGroups
      enableAI
      defaultRoles
      enableMeetings
      enableHubs
      enableGeo
      enableCompetitiveContentScore
      clientAILanguageModel
      contentGenerationModel
      clientAIStatus
      crawlConfigs
      internalIpRanges
      usePostHnswFilter
      exportFullConversations
      syncConfigs
      searchGuidance
      status
      deletedAt
      deletedBy
      purgeScheduledAt
      purgeStatus
      purgeSteps
      purgeError
      clonedFromEnv
      clonedAt
      __typename
    }
    message
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCrawlStatusQueryVariables,
  APITypes.GetCrawlStatusQuery
>;
export const getCrawledUrls = /* GraphQL */ `query GetCrawledUrls($organizationID: ID!, $crawlID: ID!) {
  getCrawledUrls(organizationID: $organizationID, crawlID: $crawlID) {
    statusCode
    organization {
      id
      name
      createdAt
      updatedAt
      stripePublicKey
      stripeSecretKey
      googleApiConfig
      googleApiSyncInfo
      cognitoUserPoolID
      cognitoWebClientID
      cognitoIdentityPoolID
      signUpFields
      signUpRequiredFields
      appsyncGraphqlID
      appsyncGraphqlKey
      appsyncGraphqlUrl
      deployedAt
      deployStatus
      accessGroups
      enableDiscussionGroups
      enableAI
      defaultRoles
      enableMeetings
      enableHubs
      enableGeo
      enableCompetitiveContentScore
      clientAILanguageModel
      contentGenerationModel
      clientAIStatus
      crawlConfigs
      internalIpRanges
      usePostHnswFilter
      exportFullConversations
      syncConfigs
      searchGuidance
      status
      deletedAt
      deletedBy
      purgeScheduledAt
      purgeStatus
      purgeSteps
      purgeError
      clonedFromEnv
      clonedAt
      __typename
    }
    message
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCrawledUrlsQueryVariables,
  APITypes.GetCrawledUrlsQuery
>;
export const getAiDashboard = /* GraphQL */ `query GetAiDashboard(
  $portalKey: String!
  $startDate: String!
  $endDate: String!
) {
  getAiDashboard(
    portalKey: $portalKey
    startDate: $startDate
    endDate: $endDate
  ) {
    statusCode
    message
    results
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAiDashboardQueryVariables,
  APITypes.GetAiDashboardQuery
>;
export const getPageViewStats = /* GraphQL */ `query GetPageViewStats(
  $organizationID: String!
  $startDate: String!
  $endDate: String!
  $filters: AWSJSON
) {
  getPageViewStats(
    organizationID: $organizationID
    startDate: $startDate
    endDate: $endDate
    filters: $filters
  ) {
    statusCode
    message
    results
    totals
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPageViewStatsQueryVariables,
  APITypes.GetPageViewStatsQuery
>;
export const getSessionDetail = /* GraphQL */ `query GetSessionDetail(
  $organizationID: String!
  $sessionID: String!
  $startDate: String
  $endDate: String
) {
  getSessionDetail(
    organizationID: $organizationID
    sessionID: $sessionID
    startDate: $startDate
    endDate: $endDate
  ) {
    statusCode
    message
    results
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSessionDetailQueryVariables,
  APITypes.GetSessionDetailQuery
>;
export const getSessionsList = /* GraphQL */ `query GetSessionsList(
  $organizationID: String!
  $startDate: String!
  $endDate: String!
  $limit: Int
  $offset: Int
  $filters: AWSJSON
) {
  getSessionsList(
    organizationID: $organizationID
    startDate: $startDate
    endDate: $endDate
    limit: $limit
    offset: $offset
    filters: $filters
  ) {
    statusCode
    message
    results
    totals
    allTopics
    topicCounts
    themeCounts
    typeCounts
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSessionsListQueryVariables,
  APITypes.GetSessionsListQuery
>;
export const getConversationsList = /* GraphQL */ `query GetConversationsList(
  $organizationID: String!
  $startDate: String!
  $endDate: String!
  $limit: Int
  $offset: Int
  $filters: AWSJSON
) {
  getConversationsList(
    organizationID: $organizationID
    startDate: $startDate
    endDate: $endDate
    limit: $limit
    offset: $offset
    filters: $filters
  ) {
    statusCode
    message
    results
    totals
    allTopics
    topicCounts
    themeCounts
    typeCounts
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetConversationsListQueryVariables,
  APITypes.GetConversationsListQuery
>;
export const getConversationDetail = /* GraphQL */ `query GetConversationDetail(
  $organizationID: String!
  $conversationID: String!
  $startDate: String
  $endDate: String
) {
  getConversationDetail(
    organizationID: $organizationID
    conversationID: $conversationID
    startDate: $startDate
    endDate: $endDate
  ) {
    statusCode
    message
    results
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetConversationDetailQueryVariables,
  APITypes.GetConversationDetailQuery
>;
export const getSessionsGeography = /* GraphQL */ `query GetSessionsGeography(
  $organizationID: String!
  $startDate: String!
  $endDate: String!
  $filters: AWSJSON
) {
  getSessionsGeography(
    organizationID: $organizationID
    startDate: $startDate
    endDate: $endDate
    filters: $filters
  ) {
    statusCode
    message
    results
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSessionsGeographyQueryVariables,
  APITypes.GetSessionsGeographyQuery
>;
export const getPageViewsGeography = /* GraphQL */ `query GetPageViewsGeography(
  $organizationID: String!
  $startDate: String!
  $endDate: String!
  $filters: AWSJSON
) {
  getPageViewsGeography(
    organizationID: $organizationID
    startDate: $startDate
    endDate: $endDate
    filters: $filters
  ) {
    statusCode
    message
    results
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPageViewsGeographyQueryVariables,
  APITypes.GetPageViewsGeographyQuery
>;
export const getEventsForSession = /* GraphQL */ `query GetEventsForSession(
  $organizationID: String!
  $sessionID: String!
  $startDate: String
  $endDate: String
) {
  getEventsForSession(
    organizationID: $organizationID
    sessionID: $sessionID
    startDate: $startDate
    endDate: $endDate
  ) {
    statusCode
    message
    results
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEventsForSessionQueryVariables,
  APITypes.GetEventsForSessionQuery
>;
export const getPageViewsForUrl = /* GraphQL */ `query GetPageViewsForUrl(
  $organizationID: String!
  $startDate: String!
  $endDate: String!
  $urlMatch: String!
  $filters: AWSJSON
) {
  getPageViewsForUrl(
    organizationID: $organizationID
    startDate: $startDate
    endDate: $endDate
    urlMatch: $urlMatch
    filters: $filters
  ) {
    statusCode
    message
    results
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPageViewsForUrlQueryVariables,
  APITypes.GetPageViewsForUrlQuery
>;
export const getTopProducts = /* GraphQL */ `query GetTopProducts(
  $organizationID: String!
  $startDate: String!
  $endDate: String!
) {
  getTopProducts(
    organizationID: $organizationID
    startDate: $startDate
    endDate: $endDate
  ) {
    statusCode
    message
    results
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTopProductsQueryVariables,
  APITypes.GetTopProductsQuery
>;
export const getConversationSummary = /* GraphQL */ `query GetConversationSummary(
  $organizationID: String!
  $startDate: String!
  $endDate: String!
  $timezoneOffset: String
) {
  getConversationSummary(
    organizationID: $organizationID
    startDate: $startDate
    endDate: $endDate
    timezoneOffset: $timezoneOffset
  ) {
    statusCode
    message
    results
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetConversationSummaryQueryVariables,
  APITypes.GetConversationSummaryQuery
>;
export const getTopicsHierarchy = /* GraphQL */ `query GetTopicsHierarchy($organizationID: String!) {
  getTopicsHierarchy(organizationID: $organizationID) {
    statusCode
    message
    results
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTopicsHierarchyQueryVariables,
  APITypes.GetTopicsHierarchyQuery
>;
export const getGeoReporting = /* GraphQL */ `query GetGeoReporting(
  $organizationID: String!
  $startDate: String!
  $endDate: String!
  $timezone: String
) {
  getGeoReporting(
    organizationID: $organizationID
    startDate: $startDate
    endDate: $endDate
    timezone: $timezone
  )
}
` as GeneratedQuery<
  APITypes.GetGeoReportingQueryVariables,
  APITypes.GetGeoReportingQuery
>;
export const getGeoGuideDrilldown = /* GraphQL */ `query GetGeoGuideDrilldown(
  $organizationID: String!
  $guideId: String!
  $startDate: String!
  $endDate: String!
) {
  getGeoGuideDrilldown(
    organizationID: $organizationID
    guideId: $guideId
    startDate: $startDate
    endDate: $endDate
  )
}
` as GeneratedQuery<
  APITypes.GetGeoGuideDrilldownQueryVariables,
  APITypes.GetGeoGuideDrilldownQuery
>;
export const getGeoClusterDashboard = /* GraphQL */ `query GetGeoClusterDashboard(
  $organizationID: String!
  $clusterId: String!
  $startDate: String!
  $endDate: String!
) {
  getGeoClusterDashboard(
    organizationID: $organizationID
    clusterId: $clusterId
    startDate: $startDate
    endDate: $endDate
  )
}
` as GeneratedQuery<
  APITypes.GetGeoClusterDashboardQueryVariables,
  APITypes.GetGeoClusterDashboardQuery
>;
export const getGeoGuideDashboard = /* GraphQL */ `query GetGeoGuideDashboard(
  $organizationID: String!
  $guideId: String!
  $startDate: String!
  $endDate: String!
) {
  getGeoGuideDashboard(
    organizationID: $organizationID
    guideId: $guideId
    startDate: $startDate
    endDate: $endDate
  )
}
` as GeneratedQuery<
  APITypes.GetGeoGuideDashboardQueryVariables,
  APITypes.GetGeoGuideDashboardQuery
>;
export const getGeoJourney = /* GraphQL */ `query GetGeoJourney(
  $organizationID: String!
  $startDate: String!
  $endDate: String!
  $guideId: String
  $clusterId: String
) {
  getGeoJourney(
    organizationID: $organizationID
    startDate: $startDate
    endDate: $endDate
    guideId: $guideId
    clusterId: $clusterId
  )
}
` as GeneratedQuery<
  APITypes.GetGeoJourneyQueryVariables,
  APITypes.GetGeoJourneyQuery
>;
export const getGeoCrawl = /* GraphQL */ `query GetGeoCrawl(
  $organizationID: String!
  $startDate: String!
  $endDate: String!
) {
  getGeoCrawl(
    organizationID: $organizationID
    startDate: $startDate
    endDate: $endDate
  )
}
` as GeneratedQuery<
  APITypes.GetGeoCrawlQueryVariables,
  APITypes.GetGeoCrawlQuery
>;
export const getGeoAssistant = /* GraphQL */ `query GetGeoAssistant(
  $organizationID: String!
  $startDate: String!
  $endDate: String!
) {
  getGeoAssistant(
    organizationID: $organizationID
    startDate: $startDate
    endDate: $endDate
  )
}
` as GeneratedQuery<
  APITypes.GetGeoAssistantQueryVariables,
  APITypes.GetGeoAssistantQuery
>;
export const getGeoAttribution = /* GraphQL */ `query GetGeoAttribution(
  $organizationID: String!
  $startDate: String!
  $endDate: String!
  $window: String
  $model: String
  $entity: String
) {
  getGeoAttribution(
    organizationID: $organizationID
    startDate: $startDate
    endDate: $endDate
    window: $window
    model: $model
    entity: $entity
  )
}
` as GeneratedQuery<
  APITypes.GetGeoAttributionQueryVariables,
  APITypes.GetGeoAttributionQuery
>;
export const getAttribution = /* GraphQL */ `query GetAttribution(
  $organizationID: String!
  $portalID: String
  $startDate: String!
  $endDate: String!
  $timezone: String
  $window: String
  $model: String
  $lane: String
  $contentKinds: [String]
) {
  getAttribution(
    organizationID: $organizationID
    portalID: $portalID
    startDate: $startDate
    endDate: $endDate
    timezone: $timezone
    window: $window
    model: $model
    lane: $lane
    contentKinds: $contentKinds
  )
}
` as GeneratedQuery<
  APITypes.GetAttributionQueryVariables,
  APITypes.GetAttributionQuery
>;
export const checkProductFeedStatus = /* GraphQL */ `query CheckProductFeedStatus(
  $organizationID: String!
  $feedType: String!
  $id: String!
) {
  checkProductFeedStatus(
    organizationID: $organizationID
    feedType: $feedType
    id: $id
  ) {
    productFeed {
      lastStarted
      lastCompleted
      status
      message
      products
      __typename
    }
    currentStatus
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CheckProductFeedStatusQueryVariables,
  APITypes.CheckProductFeedStatusQuery
>;
export const productPageContent = /* GraphQL */ `query ProductPageContent(
  $organizationID: String!
  $productID: String!
  $portalID: String
  $locale: String
) {
  productPageContent(
    organizationID: $organizationID
    productID: $productID
    portalID: $portalID
    locale: $locale
  ) {
    status
    message
    createdAt
    systemPrompt
    modelID
    suggestedPrompts
    smartSummary {
      header
      generatedByAiLabel
      __typename
    }
    seoContent {
      metaDescription
      geoSummary
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductPageContentQueryVariables,
  APITypes.ProductPageContentQuery
>;
export const portalSuggestedPromptAnswers = /* GraphQL */ `query PortalSuggestedPromptAnswers(
  $organizationID: String!
  $portalID: String!
  $locale: String
) {
  portalSuggestedPromptAnswers(
    organizationID: $organizationID
    portalID: $portalID
    locale: $locale
  ) {
    status
    message
    locales
    items {
      prompt
      promptType
      locale
      answer
      cacheStatus
      cachedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PortalSuggestedPromptAnswersQueryVariables,
  APITypes.PortalSuggestedPromptAnswersQuery
>;
export const getWebPixelStatus = /* GraphQL */ `query GetWebPixelStatus($organizationID: String!, $shopifyConfigId: String!) {
  getWebPixelStatus(
    organizationID: $organizationID
    shopifyConfigId: $shopifyConfigId
  ) {
    exists
    id
    settings {
      organizationID
      beaconURL
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetWebPixelStatusQueryVariables,
  APITypes.GetWebPixelStatusQuery
>;
export const getShopifySubscriptionStatus = /* GraphQL */ `query GetShopifySubscriptionStatus(
  $organizationID: String!
  $shopifyConfigId: String!
) {
  getShopifySubscriptionStatus(
    organizationID: $organizationID
    shopifyConfigId: $shopifyConfigId
  ) {
    subscriptions {
      id
      name
      status
      createdAt
      currentPeriodEnd
      __typename
    }
    shop {
      name
      id
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetShopifySubscriptionStatusQueryVariables,
  APITypes.GetShopifySubscriptionStatusQuery
>;
export const getShopifyGrantedScopes = /* GraphQL */ `query GetShopifyGrantedScopes(
  $organizationID: String!
  $shopifyConfigId: String!
) {
  getShopifyGrantedScopes(
    organizationID: $organizationID
    shopifyConfigId: $shopifyConfigId
  ) {
    accessScopes {
      handle
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetShopifyGrantedScopesQueryVariables,
  APITypes.GetShopifyGrantedScopesQuery
>;
export const listAdminTasks = /* GraphQL */ `query ListAdminTasks($organizationID: ID!, $filter: AdminTaskFilter) {
  listAdminTasks(organizationID: $organizationID, filter: $filter) {
    items {
      id
      organizationID
      taskType
      status
      percent
      phase
      detail
      error
      visibilityScope
      ownerUserId
      initiatedBy
      correlation
      resultRef
      traceId
      input
      heartbeatAt
      attempt
      nextPollAt
      providerState
      ttl
      createdAt
      updatedAt
      completedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAdminTasksQueryVariables,
  APITypes.ListAdminTasksQuery
>;
export const getAdminTask = /* GraphQL */ `query GetAdminTask($organizationID: ID!, $id: ID!) {
  getAdminTask(organizationID: $organizationID, id: $id) {
    id
    organizationID
    taskType
    status
    percent
    phase
    detail
    error
    visibilityScope
    ownerUserId
    initiatedBy
    correlation
    resultRef
    traceId
    input
    heartbeatAt
    attempt
    nextPollAt
    providerState
    ttl
    createdAt
    updatedAt
    completedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAdminTaskQueryVariables,
  APITypes.GetAdminTaskQuery
>;
export const listGeoDiscoveries = /* GraphQL */ `query ListGeoDiscoveries(
  $organizationID: ID!
  $status: String
  $limit: Int
  $nextToken: String
) {
  listGeoDiscoveries(
    organizationID: $organizationID
    status: $status
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      portalID
      status
      inputUrl
      inputParams
      proposals
      outputSummary
      errorMessage
      userId
      relatedTaskId
      requestKey
      lockScope
      fence
      admission
      jobId
      createdAt
      updatedAt
      completedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListGeoDiscoveriesQueryVariables,
  APITypes.ListGeoDiscoveriesQuery
>;
export const getGeoDiscovery = /* GraphQL */ `query GetGeoDiscovery($organizationID: ID!, $id: ID!) {
  getGeoDiscovery(organizationID: $organizationID, id: $id) {
    id
    organizationID
    portalID
    status
    inputUrl
    inputParams
    proposals
    outputSummary
    errorMessage
    userId
    relatedTaskId
    requestKey
    lockScope
    fence
    admission
    jobId
    createdAt
    updatedAt
    completedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetGeoDiscoveryQueryVariables,
  APITypes.GetGeoDiscoveryQuery
>;
export const adminTaskEventsByTask = /* GraphQL */ `query AdminTaskEventsByTask(
  $taskId: ID
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAdminTaskEventFilterInput
  $limit: Int
  $nextToken: String
) {
  adminTaskEventsByTask(
    taskId: $taskId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      taskId
      traceId
      createdAt
      seq
      type
      phase
      message
      data
      ttl
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AdminTaskEventsByTaskQueryVariables,
  APITypes.AdminTaskEventsByTaskQuery
>;
export const getAsset = /* GraphQL */ `query GetAsset($organizationID: ID!, $id: ID!) {
  getAsset(organizationID: $organizationID, id: $id) {
    id
    organizationID
    createdAt
    updatedAt
    externalID
    repositoryID
    name
    key
    description
    type
    tags
    mimeType
    derivativeStatus
    transcribeStatus
    status
    access
    dominantColor
    length
    transcript
    scormManifest
    useHls
    hlsGenerated
    __typename
  }
}
` as GeneratedQuery<APITypes.GetAssetQueryVariables, APITypes.GetAssetQuery>;
export const listAssets = /* GraphQL */ `query ListAssets(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelAssetFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAssets(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      createdAt
      updatedAt
      externalID
      repositoryID
      name
      key
      description
      type
      tags
      mimeType
      derivativeStatus
      transcribeStatus
      status
      access
      dominantColor
      length
      transcript
      scormManifest
      useHls
      hlsGenerated
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAssetsQueryVariables,
  APITypes.ListAssetsQuery
>;
export const getCertificate = /* GraphQL */ `query GetCertificate($organizationID: ID!, $id: ID!) {
  getCertificate(organizationID: $organizationID, id: $id) {
    id
    organizationID
    certificationID
    customerID
    createdAt
    updatedAt
    awardedAt
    score
    progressPercentage
    courseKey
    programKey
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCertificateQueryVariables,
  APITypes.GetCertificateQuery
>;
export const listCertificates = /* GraphQL */ `query ListCertificates(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelCertificateFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCertificates(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      certificationID
      customerID
      createdAt
      updatedAt
      awardedAt
      score
      progressPercentage
      courseKey
      programKey
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCertificatesQueryVariables,
  APITypes.ListCertificatesQuery
>;
export const getCertificateByCustomerID = /* GraphQL */ `query GetCertificateByCustomerID(
  $organizationID: ID
  $customerID: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCertificateFilterInput
  $limit: Int
  $nextToken: String
) {
  getCertificateByCustomerID(
    organizationID: $organizationID
    customerID: $customerID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      certificationID
      customerID
      createdAt
      updatedAt
      awardedAt
      score
      progressPercentage
      courseKey
      programKey
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCertificateByCustomerIDQueryVariables,
  APITypes.GetCertificateByCustomerIDQuery
>;
export const getCertification = /* GraphQL */ `query GetCertification($organizationID: ID!, $id: ID!) {
  getCertification(organizationID: $organizationID, id: $id) {
    id
    organizationID
    createdAt
    updatedAt
    name
    description
    template
    poster
    fields
    emailTemplateID
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCertificationQueryVariables,
  APITypes.GetCertificationQuery
>;
export const listCertifications = /* GraphQL */ `query ListCertifications(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelCertificationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCertifications(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      createdAt
      updatedAt
      name
      description
      template
      poster
      fields
      emailTemplateID
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCertificationsQueryVariables,
  APITypes.ListCertificationsQuery
>;
export const getClientAi = /* GraphQL */ `query GetClientAi($organizationID: ID!, $id: ID!) {
  getClientAi(organizationID: $organizationID, id: $id) {
    id
    organizationID
    libraries
    createdAt
    updatedAt
    externalID
    name
    headline
    active
    referrers
    initialState
    portalKey
    page
    searchPortalKey
    searchPage
    inlinePortalKey
    inlinePage
    aiSearchButtonConfig
    buttonConfig
    popupConfig
    mobilePopupConfig
    minimizedConfig
    customInitCode
    customCartUpdateCode
    customProductDescriptionSanitizerCode
    autoOpenConfig
    inlineWidgetWidth
    inlineMinHeight
    inlineMaxHeight
    initialHeight
    autoMinimizeOnBlur
    searchOverrides
    disableConversationPersistence
    platform
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetClientAiQueryVariables,
  APITypes.GetClientAiQuery
>;
export const listClientAis = /* GraphQL */ `query ListClientAis(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelClientAiFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listClientAis(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      libraries
      createdAt
      updatedAt
      externalID
      name
      headline
      active
      referrers
      initialState
      portalKey
      page
      searchPortalKey
      searchPage
      inlinePortalKey
      inlinePage
      aiSearchButtonConfig
      buttonConfig
      popupConfig
      mobilePopupConfig
      minimizedConfig
      customInitCode
      customCartUpdateCode
      customProductDescriptionSanitizerCode
      autoOpenConfig
      inlineWidgetWidth
      inlineMinHeight
      inlineMaxHeight
      initialHeight
      autoMinimizeOnBlur
      searchOverrides
      disableConversationPersistence
      platform
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListClientAisQueryVariables,
  APITypes.ListClientAisQuery
>;
export const getCourse = /* GraphQL */ `query GetCourse($organizationID: ID!, $id: ID!) {
  getCourse(organizationID: $organizationID, id: $id) {
    id
    organizationID
    slug
    manualSlug
    format
    libraries
    createdAt
    updatedAt
    externalID
    name
    active
    headline
    description
    objectives
    tags
    keywords
    level
    length
    courseImage
    courseImageThumbnail
    promoVideo
    posterImage
    sharePassword
    audience
    requiredSkills
    gated
    confirmationMessage
    welcomeMessage
    congratulatoryMessage
    startDate
    expiryDate
    searchable
    sections
    reviews
    currency
    discountPercent
    avgRating
    reviewsCount
    courseLessons
    price
    sellPrice
    certification
    companyName
    enrollmentCount
    lessonCount
    faqs
    instructors
    searchInstructors
    ctaUrl
    ctaLabel
    ctaNewWindow
    accessConfiguration
    accessGroups
    excludeFromAllCourses
    portalKicker
    prerequisiteMessage
    prerequisiteCertificates
    richText1
    richText2
    richText3
    richText4
    richText5
    richText6
    richText7
    richText8
    richText9
    richText10
    enrollmentOffered
    aiWizardContent
    discussionTopic
    doNotIndex
    doNotReference
    ogImage
    enableAutoplay
    __typename
  }
}
` as GeneratedQuery<APITypes.GetCourseQueryVariables, APITypes.GetCourseQuery>;
export const listCourses = /* GraphQL */ `query ListCourses(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelCourseFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCourses(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      slug
      manualSlug
      format
      libraries
      createdAt
      updatedAt
      externalID
      name
      active
      headline
      description
      objectives
      tags
      keywords
      level
      length
      courseImage
      courseImageThumbnail
      promoVideo
      posterImage
      sharePassword
      audience
      requiredSkills
      gated
      confirmationMessage
      welcomeMessage
      congratulatoryMessage
      startDate
      expiryDate
      searchable
      sections
      reviews
      currency
      discountPercent
      avgRating
      reviewsCount
      courseLessons
      price
      sellPrice
      certification
      companyName
      enrollmentCount
      lessonCount
      faqs
      instructors
      searchInstructors
      ctaUrl
      ctaLabel
      ctaNewWindow
      accessConfiguration
      accessGroups
      excludeFromAllCourses
      portalKicker
      prerequisiteMessage
      prerequisiteCertificates
      richText1
      richText2
      richText3
      richText4
      richText5
      richText6
      richText7
      richText8
      richText9
      richText10
      enrollmentOffered
      aiWizardContent
      discussionTopic
      doNotIndex
      doNotReference
      ogImage
      enableAutoplay
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCoursesQueryVariables,
  APITypes.ListCoursesQuery
>;
export const getCourseProgress = /* GraphQL */ `query GetCourseProgress(
  $organizationID: ID!
  $customerID: ID!
  $courseID: ID!
  $id: ID!
) {
  getCourseProgress(
    organizationID: $organizationID
    customerID: $customerID
    courseID: $courseID
    id: $id
  ) {
    id
    organizationID
    customerID
    courseID
    createdAt
    updatedAt
    progress
    startedDate
    completeDate
    lastActiveDate
    expiryDate
    lessonProgress
    lessonsCompleted
    quizResults
    notes
    hasCertification
    certificateAwarded
    certificates
    certifications
    completedCertifications
    certificateStatus
    certificateScore
    certificateAwardedAt
    scormData
    tracking
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCourseProgressQueryVariables,
  APITypes.GetCourseProgressQuery
>;
export const listCourseProgresses = /* GraphQL */ `query ListCourseProgresses(
  $organizationID: ID
  $customerIDCourseIDId: ModelCourseProgressPrimaryCompositeKeyConditionInput
  $filter: ModelCourseProgressFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCourseProgresses(
    organizationID: $organizationID
    customerIDCourseIDId: $customerIDCourseIDId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      customerID
      courseID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      lessonProgress
      lessonsCompleted
      quizResults
      notes
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      scormData
      tracking
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCourseProgressesQueryVariables,
  APITypes.ListCourseProgressesQuery
>;
export const courseProgressByCourseIDCustomerID = /* GraphQL */ `query CourseProgressByCourseIDCustomerID(
  $courseID: ID
  $customerID: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCourseProgressFilterInput
  $limit: Int
  $nextToken: String
) {
  courseProgressByCourseIDCustomerID(
    courseID: $courseID
    customerID: $customerID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      customerID
      courseID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      lessonProgress
      lessonsCompleted
      quizResults
      notes
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      scormData
      tracking
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CourseProgressByCourseIDCustomerIDQueryVariables,
  APITypes.CourseProgressByCourseIDCustomerIDQuery
>;
export const getDiscussionTopic = /* GraphQL */ `query GetDiscussionTopic($organizationID: ID!, $id: ID!) {
  getDiscussionTopic(organizationID: $organizationID, id: $id) {
    id
    organizationID
    createdAt
    updatedAt
    name
    description
    approvalRequired
    oneOnOne
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDiscussionTopicQueryVariables,
  APITypes.GetDiscussionTopicQuery
>;
export const listDiscussionTopics = /* GraphQL */ `query ListDiscussionTopics(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelDiscussionTopicFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listDiscussionTopics(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      createdAt
      updatedAt
      name
      description
      approvalRequired
      oneOnOne
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDiscussionTopicsQueryVariables,
  APITypes.ListDiscussionTopicsQuery
>;
export const getDiscussionPost = /* GraphQL */ `query GetDiscussionPost($organizationID: ID!, $id: ID!) {
  getDiscussionPost(organizationID: $organizationID, id: $id) {
    id
    organizationID
    customerID
    userID
    approvedByID
    repliesTo
    createdAt
    updatedAt
    topicID
    name
    content
    attachment
    status
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDiscussionPostQueryVariables,
  APITypes.GetDiscussionPostQuery
>;
export const listDiscussionPosts = /* GraphQL */ `query ListDiscussionPosts(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelDiscussionPostFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listDiscussionPosts(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      customerID
      userID
      approvedByID
      repliesTo
      createdAt
      updatedAt
      topicID
      name
      content
      attachment
      status
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDiscussionPostsQueryVariables,
  APITypes.ListDiscussionPostsQuery
>;
export const getCustomer = /* GraphQL */ `query GetCustomer($organizationID: ID!, $id: ID!) {
  getCustomer(organizationID: $organizationID, id: $id) {
    id
    organizationID
    createdAt
    updatedAt
    name
    phoneNumber
    biography
    profileImage
    email
    temporaryPassword
    background
    headline
    internalNotes
    title
    hubID
    stripeCustomerID
    activeMembershipCount
    trialMembershipCount
    overdueMembershipCount
    expiredMembershipCount
    lastPaymentAt
    nextPaymentAt
    text1
    text2
    text3
    text4
    text5
    status
    learningBoards {
      nextToken
      __typename
    }
    members {
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCustomerQueryVariables,
  APITypes.GetCustomerQuery
>;
export const listCustomers = /* GraphQL */ `query ListCustomers(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelCustomerFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCustomers(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      createdAt
      updatedAt
      name
      phoneNumber
      biography
      profileImage
      email
      temporaryPassword
      background
      headline
      internalNotes
      title
      hubID
      stripeCustomerID
      activeMembershipCount
      trialMembershipCount
      overdueMembershipCount
      expiredMembershipCount
      lastPaymentAt
      nextPaymentAt
      text1
      text2
      text3
      text4
      text5
      status
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCustomersQueryVariables,
  APITypes.ListCustomersQuery
>;
export const customerByEmail = /* GraphQL */ `query CustomerByEmail(
  $organizationID: ID
  $email: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCustomerFilterInput
  $limit: Int
  $nextToken: String
) {
  customerByEmail(
    organizationID: $organizationID
    email: $email
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      createdAt
      updatedAt
      name
      phoneNumber
      biography
      profileImage
      email
      temporaryPassword
      background
      headline
      internalNotes
      title
      hubID
      stripeCustomerID
      activeMembershipCount
      trialMembershipCount
      overdueMembershipCount
      expiredMembershipCount
      lastPaymentAt
      nextPaymentAt
      text1
      text2
      text3
      text4
      text5
      status
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CustomerByEmailQueryVariables,
  APITypes.CustomerByEmailQuery
>;
export const getDocument = /* GraphQL */ `query GetDocument($organizationID: ID!, $id: ID!) {
  getDocument(organizationID: $organizationID, id: $id) {
    id
    organizationID
    slug
    manualSlug
    libraries
    createdAt
    updatedAt
    name
    publishedAt
    active
    headline
    description
    image
    asset
    content
    tags
    keywords
    level
    instructors
    searchInstructors
    searchable
    ctaUrl
    ctaLabel
    ctaNewWindow
    excludeFromAllCourses
    accessConfiguration
    accessGroups
    portalKicker
    richText1
    richText2
    richText3
    richText4
    richText5
    richText6
    richText7
    richText8
    richText9
    richText10
    discussionTopic
    ogImage
    doNotIndex
    doNotReference
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDocumentQueryVariables,
  APITypes.GetDocumentQuery
>;
export const listDocuments = /* GraphQL */ `query ListDocuments(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelDocumentFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listDocuments(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      slug
      manualSlug
      libraries
      createdAt
      updatedAt
      name
      publishedAt
      active
      headline
      description
      image
      asset
      content
      tags
      keywords
      level
      instructors
      searchInstructors
      searchable
      ctaUrl
      ctaLabel
      ctaNewWindow
      excludeFromAllCourses
      accessConfiguration
      accessGroups
      portalKicker
      richText1
      richText2
      richText3
      richText4
      richText5
      richText6
      richText7
      richText8
      richText9
      richText10
      discussionTopic
      ogImage
      doNotIndex
      doNotReference
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDocumentsQueryVariables,
  APITypes.ListDocumentsQuery
>;
export const getDocumentProgress = /* GraphQL */ `query GetDocumentProgress(
  $organizationID: ID!
  $customerID: ID!
  $documentKey: ID!
  $id: ID!
) {
  getDocumentProgress(
    organizationID: $organizationID
    customerID: $customerID
    documentKey: $documentKey
    id: $id
  ) {
    id
    organizationID
    customerID
    documentKey
    createdAt
    updatedAt
    progress
    startedDate
    completeDate
    lastActiveDate
    expiryDate
    notes
    status
    viewCount
    history
    includeInMyDocuments
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDocumentProgressQueryVariables,
  APITypes.GetDocumentProgressQuery
>;
export const listDocumentProgresses = /* GraphQL */ `query ListDocumentProgresses(
  $organizationID: ID
  $customerIDDocumentKeyId: ModelDocumentProgressPrimaryCompositeKeyConditionInput
  $filter: ModelDocumentProgressFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listDocumentProgresses(
    organizationID: $organizationID
    customerIDDocumentKeyId: $customerIDDocumentKeyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      customerID
      documentKey
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      notes
      status
      viewCount
      history
      includeInMyDocuments
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDocumentProgressesQueryVariables,
  APITypes.ListDocumentProgressesQuery
>;
export const documentProgressByDocumentKeyCustomerID = /* GraphQL */ `query DocumentProgressByDocumentKeyCustomerID(
  $documentKey: ID
  $customerID: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelDocumentProgressFilterInput
  $limit: Int
  $nextToken: String
) {
  documentProgressByDocumentKeyCustomerID(
    documentKey: $documentKey
    customerID: $customerID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      customerID
      documentKey
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      notes
      status
      viewCount
      history
      includeInMyDocuments
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DocumentProgressByDocumentKeyCustomerIDQueryVariables,
  APITypes.DocumentProgressByDocumentKeyCustomerIDQuery
>;
export const getEmailTemplate = /* GraphQL */ `query GetEmailTemplate($organizationID: ID!, $id: ID!) {
  getEmailTemplate(organizationID: $organizationID, id: $id) {
    id
    organizationID
    name
    from
    bcc
    subject
    tags
    body
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEmailTemplateQueryVariables,
  APITypes.GetEmailTemplateQuery
>;
export const listEmailTemplates = /* GraphQL */ `query ListEmailTemplates(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelEmailTemplateFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listEmailTemplates(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      name
      from
      bcc
      subject
      tags
      body
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEmailTemplatesQueryVariables,
  APITypes.ListEmailTemplatesQuery
>;
export const getEngagementHistory = /* GraphQL */ `query GetEngagementHistory($organizationID: ID!, $id: ID!) {
  getEngagementHistory(organizationID: $organizationID, id: $id) {
    id
    organizationID
    customerID
    flowID
    itemID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEngagementHistoryQueryVariables,
  APITypes.GetEngagementHistoryQuery
>;
export const listEngagementHistories = /* GraphQL */ `query ListEngagementHistories(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelEngagementHistoryFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listEngagementHistories(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      customerID
      flowID
      itemID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEngagementHistoriesQueryVariables,
  APITypes.ListEngagementHistoriesQuery
>;
export const getEngagementFlow = /* GraphQL */ `query GetEngagementFlow($organizationID: ID!, $id: ID!) {
  getEngagementFlow(organizationID: $organizationID, id: $id) {
    id
    organizationID
    name
    description
    active
    tags
    flow
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEngagementFlowQueryVariables,
  APITypes.GetEngagementFlowQuery
>;
export const listEngagementFlows = /* GraphQL */ `query ListEngagementFlows(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelEngagementFlowFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listEngagementFlows(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      name
      description
      active
      tags
      flow
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEngagementFlowsQueryVariables,
  APITypes.ListEngagementFlowsQuery
>;
export const getHub = /* GraphQL */ `query GetHub($organizationID: ID!, $id: ID!) {
  getHub(organizationID: $organizationID, id: $id) {
    id
    organizationID
    slug
    manualSlug
    defaultLibraryID
    createdAt
    updatedAt
    name
    active
    description
    logoImage
    categories
    learningBoards {
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<APITypes.GetHubQueryVariables, APITypes.GetHubQuery>;
export const listHubs = /* GraphQL */ `query ListHubs(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelHubFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listHubs(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      slug
      manualSlug
      defaultLibraryID
      createdAt
      updatedAt
      name
      active
      description
      logoImage
      categories
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListHubsQueryVariables, APITypes.ListHubsQuery>;
export const getInstructor = /* GraphQL */ `query GetInstructor($organizationID: ID!, $id: ID!) {
  getInstructor(organizationID: $organizationID, id: $id) {
    id
    organizationID
    slug
    userID
    createdAt
    updatedAt
    name
    title
    byline
    aiVisibilityAuthority
    bylineRole
    sortOrder
    biography
    profileImage
    email
    linkedInUrl
    twitterUrl
    facebookUrl
    instagramUrl
    youtubeUrl
    shopifyBioArticleId
    shopifyBioUrl
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInstructorQueryVariables,
  APITypes.GetInstructorQuery
>;
export const listInstructors = /* GraphQL */ `query ListInstructors(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelInstructorFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listInstructors(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      slug
      userID
      createdAt
      updatedAt
      name
      title
      byline
      aiVisibilityAuthority
      bylineRole
      sortOrder
      biography
      profileImage
      email
      linkedInUrl
      twitterUrl
      facebookUrl
      instagramUrl
      youtubeUrl
      shopifyBioArticleId
      shopifyBioUrl
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInstructorsQueryVariables,
  APITypes.ListInstructorsQuery
>;
export const getInvite = /* GraphQL */ `query GetInvite($id: ID!) {
  getInvite(id: $id) {
    id
    organizationID
    inviteeEmail
    invitedBy
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetInviteQueryVariables, APITypes.GetInviteQuery>;
export const listInvites = /* GraphQL */ `query ListInvites(
  $filter: ModelInviteFilterInput
  $limit: Int
  $nextToken: String
) {
  listInvites(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      organizationID
      inviteeEmail
      invitedBy
      status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInvitesQueryVariables,
  APITypes.ListInvitesQuery
>;
export const getInviteByEmail = /* GraphQL */ `query GetInviteByEmail(
  $inviteeEmail: String
  $sortDirection: ModelSortDirection
  $filter: ModelInviteFilterInput
  $limit: Int
  $nextToken: String
) {
  getInviteByEmail(
    inviteeEmail: $inviteeEmail
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      inviteeEmail
      invitedBy
      status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInviteByEmailQueryVariables,
  APITypes.GetInviteByEmailQuery
>;
export const getProfile = /* GraphQL */ `query GetProfile($organizationID: ID!, $id: ID!) {
  getProfile(organizationID: $organizationID, id: $id) {
    id
    organizationID
    portalID
    conversationID
    userID
    email
    capturedData
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProfileQueryVariables,
  APITypes.GetProfileQuery
>;
export const listProfiles = /* GraphQL */ `query ListProfiles(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelProfileFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listProfiles(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      portalID
      conversationID
      userID
      email
      capturedData
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProfilesQueryVariables,
  APITypes.ListProfilesQuery
>;
export const profilesByOrganizationCreatedAt = /* GraphQL */ `query ProfilesByOrganizationCreatedAt(
  $organizationID: ID
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProfileFilterInput
  $limit: Int
  $nextToken: String
) {
  profilesByOrganizationCreatedAt(
    organizationID: $organizationID
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      portalID
      conversationID
      userID
      email
      capturedData
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProfilesByOrganizationCreatedAtQueryVariables,
  APITypes.ProfilesByOrganizationCreatedAtQuery
>;
export const getLead = /* GraphQL */ `query GetLead($organizationID: ID!, $id: ID!) {
  getLead(organizationID: $organizationID, id: $id) {
    id
    organizationID
    createdAt
    updatedAt
    email
    firstName
    lastName
    company
    phoneNumber
    __typename
  }
}
` as GeneratedQuery<APITypes.GetLeadQueryVariables, APITypes.GetLeadQuery>;
export const listLeads = /* GraphQL */ `query ListLeads(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelLeadFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listLeads(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      createdAt
      updatedAt
      email
      firstName
      lastName
      company
      phoneNumber
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListLeadsQueryVariables, APITypes.ListLeadsQuery>;
export const getLearningBoard = /* GraphQL */ `query GetLearningBoard($organizationID: ID!, $id: ID!) {
  getLearningBoard(organizationID: $organizationID, id: $id) {
    id
    organizationID
    portalID
    customerID
    createdAt
    updatedAt
    name
    status
    sections
    learningBoardViewedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLearningBoardQueryVariables,
  APITypes.GetLearningBoardQuery
>;
export const listLearningBoards = /* GraphQL */ `query ListLearningBoards(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelLearningBoardFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listLearningBoards(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      portalID
      customerID
      createdAt
      updatedAt
      name
      status
      sections
      learningBoardViewedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLearningBoardsQueryVariables,
  APITypes.ListLearningBoardsQuery
>;
export const LearningBoardByPortalIDCustomerID = /* GraphQL */ `query LearningBoardByPortalIDCustomerID(
  $portalID: ID
  $customerID: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLearningBoardFilterInput
  $limit: Int
  $nextToken: String
) {
  LearningBoardByPortalIDCustomerID(
    portalID: $portalID
    customerID: $customerID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      portalID
      customerID
      createdAt
      updatedAt
      name
      status
      sections
      learningBoardViewedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LearningBoardByPortalIDCustomerIDQueryVariables,
  APITypes.LearningBoardByPortalIDCustomerIDQuery
>;
export const LearningBoardByCustomerIDPortalID = /* GraphQL */ `query LearningBoardByCustomerIDPortalID(
  $customerID: ID
  $portalID: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLearningBoardFilterInput
  $limit: Int
  $nextToken: String
) {
  LearningBoardByCustomerIDPortalID(
    customerID: $customerID
    portalID: $portalID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      portalID
      customerID
      createdAt
      updatedAt
      name
      status
      sections
      learningBoardViewedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LearningBoardByCustomerIDPortalIDQueryVariables,
  APITypes.LearningBoardByCustomerIDPortalIDQuery
>;
export const getLibrary = /* GraphQL */ `query GetLibrary($organizationID: ID!, $id: ID!) {
  getLibrary(organizationID: $organizationID, id: $id) {
    id
    organizationID
    createdAt
    updatedAt
    name
    description
    status
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLibraryQueryVariables,
  APITypes.GetLibraryQuery
>;
export const listLibraries = /* GraphQL */ `query ListLibraries(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelLibraryFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listLibraries(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      createdAt
      updatedAt
      name
      description
      status
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLibrariesQueryVariables,
  APITypes.ListLibrariesQuery
>;
export const getLibraryShare = /* GraphQL */ `query GetLibraryShare($organizationID: ID!, $id: ID!) {
  getLibraryShare(organizationID: $organizationID, id: $id) {
    id
    organizationID
    targetOrganizationID
    libraryID
    createdAt
    updatedAt
    name
    status
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLibraryShareQueryVariables,
  APITypes.GetLibraryShareQuery
>;
export const listLibraryShares = /* GraphQL */ `query ListLibraryShares(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelLibraryShareFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listLibraryShares(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      targetOrganizationID
      libraryID
      createdAt
      updatedAt
      name
      status
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLibrarySharesQueryVariables,
  APITypes.ListLibrarySharesQuery
>;
export const targetOrganizationIDlibraryIDstatus = /* GraphQL */ `query TargetOrganizationIDlibraryIDstatus(
  $targetOrganizationID: ID
  $libraryID: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLibraryShareFilterInput
  $limit: Int
  $nextToken: String
) {
  targetOrganizationIDlibraryIDstatus(
    targetOrganizationID: $targetOrganizationID
    libraryID: $libraryID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      targetOrganizationID
      libraryID
      createdAt
      updatedAt
      name
      status
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TargetOrganizationIDlibraryIDstatusQueryVariables,
  APITypes.TargetOrganizationIDlibraryIDstatusQuery
>;
export const getMeeting = /* GraphQL */ `query GetMeeting($organizationID: ID!, $id: ID!) {
  getMeeting(organizationID: $organizationID, id: $id) {
    id
    organizationID
    slug
    libraries
    portalID
    meetingType
    status
    createdAt
    createdByID
    updatedAt
    name
    headline
    description
    content
    instructors
    searchInstructors
    transcript
    image
    recordingID
    recordingMediaPipelineID
    preStartOpenDuration
    startsAt
    postStartGraceDuration
    plannedDuration
    actualDuration
    chimeMeeting {
      ExternalMeetingId
      MediaRegion
      MeetingArn
      MeetingId
      TenantIds
      __typename
    }
    preMeetingMessage
    postMeetingMessage
    mediaRegion
    registrationRequired
    registerBy
    restrictByAccessGroup
    accessGroups
    restrictByCustomer
    customers
    registrationCount
    registrationMax
    portalKicker
    attendees
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMeetingQueryVariables,
  APITypes.GetMeetingQuery
>;
export const listMeetings = /* GraphQL */ `query ListMeetings(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelMeetingFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listMeetings(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      slug
      libraries
      portalID
      meetingType
      status
      createdAt
      createdByID
      updatedAt
      name
      headline
      description
      content
      instructors
      searchInstructors
      transcript
      image
      recordingID
      recordingMediaPipelineID
      preStartOpenDuration
      startsAt
      postStartGraceDuration
      plannedDuration
      actualDuration
      preMeetingMessage
      postMeetingMessage
      mediaRegion
      registrationRequired
      registerBy
      restrictByAccessGroup
      accessGroups
      restrictByCustomer
      customers
      registrationCount
      registrationMax
      portalKicker
      attendees
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMeetingsQueryVariables,
  APITypes.ListMeetingsQuery
>;
export const getMeetingRegistration = /* GraphQL */ `query GetMeetingRegistration($organizationID: ID!, $id: ID!) {
  getMeetingRegistration(organizationID: $organizationID, id: $id) {
    id
    organizationID
    portalID
    customerID
    meetingID
    name
    status
    createdAt
    updatedAt
    notes
    history
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMeetingRegistrationQueryVariables,
  APITypes.GetMeetingRegistrationQuery
>;
export const listMeetingRegistrations = /* GraphQL */ `query ListMeetingRegistrations(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelMeetingRegistrationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listMeetingRegistrations(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      portalID
      customerID
      meetingID
      name
      status
      createdAt
      updatedAt
      notes
      history
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMeetingRegistrationsQueryVariables,
  APITypes.ListMeetingRegistrationsQuery
>;
export const getMeetingsByCustomerID = /* GraphQL */ `query GetMeetingsByCustomerID(
  $organizationID: ID
  $customerIDPortalIDMeetingID: ModelMeetingRegistrationGetMeetingsByCustomerIDCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelMeetingRegistrationFilterInput
  $limit: Int
  $nextToken: String
) {
  getMeetingsByCustomerID(
    organizationID: $organizationID
    customerIDPortalIDMeetingID: $customerIDPortalIDMeetingID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      portalID
      customerID
      meetingID
      name
      status
      createdAt
      updatedAt
      notes
      history
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMeetingsByCustomerIDQueryVariables,
  APITypes.GetMeetingsByCustomerIDQuery
>;
export const getCustomersByMeetingID = /* GraphQL */ `query GetCustomersByMeetingID(
  $organizationID: ID
  $meetingIDCustomerID: ModelMeetingRegistrationGetCustomersByMeetingIDCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelMeetingRegistrationFilterInput
  $limit: Int
  $nextToken: String
) {
  getCustomersByMeetingID(
    organizationID: $organizationID
    meetingIDCustomerID: $meetingIDCustomerID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      portalID
      customerID
      meetingID
      name
      status
      createdAt
      updatedAt
      notes
      history
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCustomersByMeetingIDQueryVariables,
  APITypes.GetCustomersByMeetingIDQuery
>;
export const getMember = /* GraphQL */ `query GetMember($organizationID: ID!, $id: ID!) {
  getMember(organizationID: $organizationID, id: $id) {
    id
    organizationID
    customerID
    portalID
    membershipID
    name
    status
    createdAt
    updatedAt
    expiresOn
    lastPaymentAt
    nextPaymentAt
    failedPaymentAttempts
    stripeSessionID
    stripePaymentIntentID
    stripeSubscriptionID
    stripeCustomerID
    stripeInvoiceID
    stripeExpiresAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetMemberQueryVariables, APITypes.GetMemberQuery>;
export const listMembers = /* GraphQL */ `query ListMembers(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelMemberFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listMembers(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      customerID
      portalID
      membershipID
      name
      status
      createdAt
      updatedAt
      expiresOn
      lastPaymentAt
      nextPaymentAt
      failedPaymentAttempts
      stripeSessionID
      stripePaymentIntentID
      stripeSubscriptionID
      stripeCustomerID
      stripeInvoiceID
      stripeExpiresAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMembersQueryVariables,
  APITypes.ListMembersQuery
>;
export const getMemberByCustomerID = /* GraphQL */ `query GetMemberByCustomerID(
  $organizationID: ID
  $customerID: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelMemberFilterInput
  $limit: Int
  $nextToken: String
) {
  getMemberByCustomerID(
    organizationID: $organizationID
    customerID: $customerID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      customerID
      portalID
      membershipID
      name
      status
      createdAt
      updatedAt
      expiresOn
      lastPaymentAt
      nextPaymentAt
      failedPaymentAttempts
      stripeSessionID
      stripePaymentIntentID
      stripeSubscriptionID
      stripeCustomerID
      stripeInvoiceID
      stripeExpiresAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMemberByCustomerIDQueryVariables,
  APITypes.GetMemberByCustomerIDQuery
>;
export const getMembership = /* GraphQL */ `query GetMembership($organizationID: ID!, $id: ID!) {
  getMembership(organizationID: $organizationID, id: $id) {
    id
    organizationID
    portalID
    type
    typeID
    createdAt
    updatedAt
    name
    maxMembers
    activeMembers
    description
    active
    startDate
    endDate
    paymentPlan
    recurringPrice
    recurringTerm
    installmentPrice
    installmentCount
    installmentRecurrence
    onetimePrice
    onetimeEnableExpiry
    onetimeExpireDays
    installmentEnableExpiry
    installmentExpireDays
    trialEnabled
    trialDays
    taxExempt
    courses
    categories
    accessGroups
    confirmationMessage
    orderConfirmationEmailID
    upgradeMembershipID
    downgradeMembershipID
    emailAllowedDomains
    emailDomainMismatchError
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMembershipQueryVariables,
  APITypes.GetMembershipQuery
>;
export const listMemberships = /* GraphQL */ `query ListMemberships(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelMembershipFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listMemberships(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      portalID
      type
      typeID
      createdAt
      updatedAt
      name
      maxMembers
      activeMembers
      description
      active
      startDate
      endDate
      paymentPlan
      recurringPrice
      recurringTerm
      installmentPrice
      installmentCount
      installmentRecurrence
      onetimePrice
      onetimeEnableExpiry
      onetimeExpireDays
      installmentEnableExpiry
      installmentExpireDays
      trialEnabled
      trialDays
      taxExempt
      courses
      categories
      accessGroups
      confirmationMessage
      orderConfirmationEmailID
      upgradeMembershipID
      downgradeMembershipID
      emailAllowedDomains
      emailDomainMismatchError
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMembershipsQueryVariables,
  APITypes.ListMembershipsQuery
>;
export const getMicrocast = /* GraphQL */ `query GetMicrocast($organizationID: ID!, $id: ID!) {
  getMicrocast(organizationID: $organizationID, id: $id) {
    id
    organizationID
    slug
    manualSlug
    format
    libraries
    createdAt
    updatedAt
    name
    active
    headline
    description
    microcastImage
    useAsPoster
    microcastAsset
    scormAsset
    posterImage
    content
    tags
    keywords
    level
    instructors
    searchInstructors
    searchable
    ctaUrl
    ctaLabel
    ctaNewWindow
    excludeFromAllCourses
    accessConfiguration
    accessGroups
    portalKicker
    richText1
    richText2
    richText3
    richText4
    richText5
    richText6
    richText7
    richText8
    richText9
    richText10
    discussionTopic
    disableSeekAhead
    ogImage
    doNotIndex
    doNotReference
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMicrocastQueryVariables,
  APITypes.GetMicrocastQuery
>;
export const listMicrocasts = /* GraphQL */ `query ListMicrocasts(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelMicrocastFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listMicrocasts(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      slug
      manualSlug
      format
      libraries
      createdAt
      updatedAt
      name
      active
      headline
      description
      microcastImage
      useAsPoster
      microcastAsset
      scormAsset
      posterImage
      content
      tags
      keywords
      level
      instructors
      searchInstructors
      searchable
      ctaUrl
      ctaLabel
      ctaNewWindow
      excludeFromAllCourses
      accessConfiguration
      accessGroups
      portalKicker
      richText1
      richText2
      richText3
      richText4
      richText5
      richText6
      richText7
      richText8
      richText9
      richText10
      discussionTopic
      disableSeekAhead
      ogImage
      doNotIndex
      doNotReference
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMicrocastsQueryVariables,
  APITypes.ListMicrocastsQuery
>;
export const getMicrocastProgress = /* GraphQL */ `query GetMicrocastProgress(
  $organizationID: ID!
  $customerID: ID!
  $microcastID: ID!
  $id: ID!
) {
  getMicrocastProgress(
    organizationID: $organizationID
    customerID: $customerID
    microcastID: $microcastID
    id: $id
  ) {
    id
    organizationID
    customerID
    microcastID
    createdAt
    updatedAt
    progress
    startedDate
    completeDate
    lastActiveDate
    expiryDate
    notes
    scormData
    lastPosition
    maxPosition
    tracking
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMicrocastProgressQueryVariables,
  APITypes.GetMicrocastProgressQuery
>;
export const listMicrocastProgresses = /* GraphQL */ `query ListMicrocastProgresses(
  $organizationID: ID
  $customerIDMicrocastIDId: ModelMicrocastProgressPrimaryCompositeKeyConditionInput
  $filter: ModelMicrocastProgressFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listMicrocastProgresses(
    organizationID: $organizationID
    customerIDMicrocastIDId: $customerIDMicrocastIDId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      customerID
      microcastID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      notes
      scormData
      lastPosition
      maxPosition
      tracking
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMicrocastProgressesQueryVariables,
  APITypes.ListMicrocastProgressesQuery
>;
export const microcastProgressByMicrocastIDCustomerID = /* GraphQL */ `query MicrocastProgressByMicrocastIDCustomerID(
  $microcastID: ID
  $customerID: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelMicrocastProgressFilterInput
  $limit: Int
  $nextToken: String
) {
  microcastProgressByMicrocastIDCustomerID(
    microcastID: $microcastID
    customerID: $customerID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      customerID
      microcastID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      notes
      scormData
      lastPosition
      maxPosition
      tracking
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MicrocastProgressByMicrocastIDCustomerIDQueryVariables,
  APITypes.MicrocastProgressByMicrocastIDCustomerIDQuery
>;
export const getOrganization = /* GraphQL */ `query GetOrganization($id: ID!) {
  getOrganization(id: $id) {
    id
    name
    createdAt
    updatedAt
    stripePublicKey
    stripeSecretKey
    googleApiConfig
    googleApiSyncInfo
    cognitoUserPoolID
    cognitoWebClientID
    cognitoIdentityPoolID
    signUpFields
    signUpRequiredFields
    appsyncGraphqlID
    appsyncGraphqlKey
    appsyncGraphqlUrl
    deployedAt
    deployStatus
    Courses {
      id
      organizationID
      slug
      manualSlug
      format
      libraries
      createdAt
      updatedAt
      externalID
      name
      active
      headline
      description
      objectives
      tags
      keywords
      level
      length
      courseImage
      courseImageThumbnail
      promoVideo
      posterImage
      sharePassword
      audience
      requiredSkills
      gated
      confirmationMessage
      welcomeMessage
      congratulatoryMessage
      startDate
      expiryDate
      searchable
      sections
      reviews
      currency
      discountPercent
      avgRating
      reviewsCount
      courseLessons
      price
      sellPrice
      certification
      companyName
      enrollmentCount
      lessonCount
      faqs
      instructors
      searchInstructors
      ctaUrl
      ctaLabel
      ctaNewWindow
      accessConfiguration
      accessGroups
      excludeFromAllCourses
      portalKicker
      prerequisiteMessage
      prerequisiteCertificates
      richText1
      richText2
      richText3
      richText4
      richText5
      richText6
      richText7
      richText8
      richText9
      richText10
      enrollmentOffered
      aiWizardContent
      discussionTopic
      doNotIndex
      doNotReference
      ogImage
      enableAutoplay
      __typename
    }
    Portals {
      id
      organizationID
      defaultLibraryID
      libraries
      libraryShares
      createdAt
      updatedAt
      name
      active
      publicName
      publicDomain
      sslDomain
      description
      type
      allowSearch
      enableInstructors
      requireSignature
      logoImage
      faviconImage
      ogImage
      categories
      pageDefaults
      pageRules
      componentConfigs
      termsOfService
      cardShowPrice
      publicCardShowActionButton
      publicCardButtonLabel
      publicCardAction
      publicLandingPageButtonLabel
      membershipCardShowActionButton
      membershipCardWithAccessButtonLabel
      membershipCardWithAccessAction
      membershipCardNoAccessButtonLabel
      membershipCardNoAccessAction
      membershipLandingPageWithAccessButtonLabel
      membershipLandingPageNoAccessButtonLabel
      membershipLandingPageNoAccessMembershipAction
      commerceCardShowActionButton
      commerceCardNoAccessButtonLabel
      commerceCardNoAccessAction
      commerceCardWithAccessButtonLabel
      commerceCardWithAccessAction
      commerceLandingPageWithAccessButtonLabel
      commerceLandingPageNoAccessButtonLabel
      commerceLandingPageNoAccessAction
      primaryMembershipID
      membershipOfferPageID
      noAccessImage
      learningBoardGroupNames
      stylesheet
      tokens
      supportedLocales
      defaultCheckoutConfirmationMessage
      courseCardShowImage
      courseCardShowTitle
      courseCardShowInstructor
      courseCardShowDesc
      courseCardShowInfoBar
      courseCardShowActionButton
      courseCardShowLessonCount
      showCertification
      orderConfirmationEmailID
      newCustomerMembershipID
      showLearningBoard
      showUserNameInLearningBoard
      trackDeskTenantId
      cloudfrontDistributionID
      cloudfrontDistributionDomain
      deployedAt
      deployStatus
      googleAnalyticsTagID
      programLandingWithAccessCourseAction
      footerScripts
      repositoryOriginAccessIdentityID
      clientAIAnswerLength
      clientAIFeedbackButtons
      clientAIPromptPlaceholder
      clientAISuggestedPrompts
      clientAIPersistentPrompts
      clientAIPromptTemplate
      clientAIStartingMessage
      clientAIInlineReferences
      clientAISuggestRefinements
      clientAIAdditionalInstructions
      clientAIConfig
      learningBoardConfig
      addToCartEnabled
      productCardConfig
      aiSearchConfig
      clientAIBaseUrl
      showQuizResultsTab
      status
      purgeStatus
      purgeSteps
      purgeError
      __typename
    }
    accessGroups
    enableDiscussionGroups
    enableAI
    defaultRoles
    enableMeetings
    enableHubs
    enableGeo
    enableCompetitiveContentScore
    clientAILanguageModel
    contentGenerationModel
    clientAIStatus
    crawlConfigs
    internalIpRanges
    usePostHnswFilter
    exportFullConversations
    syncConfigs
    searchGuidance
    status
    deletedAt
    deletedBy
    purgeScheduledAt
    purgeStatus
    purgeSteps
    purgeError
    clonedFromEnv
    clonedAt
    Users {
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetOrganizationQueryVariables,
  APITypes.GetOrganizationQuery
>;
export const listOrganizations = /* GraphQL */ `query ListOrganizations(
  $filter: ModelOrganizationFilterInput
  $limit: Int
  $nextToken: String
) {
  listOrganizations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      createdAt
      updatedAt
      stripePublicKey
      stripeSecretKey
      googleApiConfig
      googleApiSyncInfo
      cognitoUserPoolID
      cognitoWebClientID
      cognitoIdentityPoolID
      signUpFields
      signUpRequiredFields
      appsyncGraphqlID
      appsyncGraphqlKey
      appsyncGraphqlUrl
      deployedAt
      deployStatus
      accessGroups
      enableDiscussionGroups
      enableAI
      defaultRoles
      enableMeetings
      enableHubs
      enableGeo
      enableCompetitiveContentScore
      clientAILanguageModel
      contentGenerationModel
      clientAIStatus
      crawlConfigs
      internalIpRanges
      usePostHnswFilter
      exportFullConversations
      syncConfigs
      searchGuidance
      status
      deletedAt
      deletedBy
      purgeScheduledAt
      purgeStatus
      purgeSteps
      purgeError
      clonedFromEnv
      clonedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListOrganizationsQueryVariables,
  APITypes.ListOrganizationsQuery
>;
export const getPayment = /* GraphQL */ `query GetPayment($id: ID!) {
  getPayment(id: $id) {
    id
    organizationID
    customerID
    membershipID
    referenceID
    sessionID
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPaymentQueryVariables,
  APITypes.GetPaymentQuery
>;
export const listPayments = /* GraphQL */ `query ListPayments(
  $filter: ModelPaymentFilterInput
  $limit: Int
  $nextToken: String
) {
  listPayments(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      organizationID
      customerID
      membershipID
      referenceID
      sessionID
      status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPaymentsQueryVariables,
  APITypes.ListPaymentsQuery
>;
export const getPaymentByReferenceId = /* GraphQL */ `query GetPaymentByReferenceId(
  $referenceID: String
  $sortDirection: ModelSortDirection
  $filter: ModelPaymentFilterInput
  $limit: Int
  $nextToken: String
) {
  getPaymentByReferenceId(
    referenceID: $referenceID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      customerID
      membershipID
      referenceID
      sessionID
      status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPaymentByReferenceIdQueryVariables,
  APITypes.GetPaymentByReferenceIdQuery
>;
export const getPortal = /* GraphQL */ `query GetPortal($organizationID: ID!, $id: ID!) {
  getPortal(organizationID: $organizationID, id: $id) {
    id
    organizationID
    defaultLibraryID
    libraries
    libraryShares
    createdAt
    updatedAt
    name
    active
    publicName
    publicDomain
    sslDomain
    description
    type
    allowSearch
    enableInstructors
    requireSignature
    defaultInstructorImage {
      id
      organizationID
      createdAt
      updatedAt
      externalID
      repositoryID
      name
      key
      description
      type
      tags
      mimeType
      derivativeStatus
      transcribeStatus
      status
      access
      dominantColor
      length
      transcript
      scormManifest
      useHls
      hlsGenerated
      __typename
    }
    logoImage
    faviconImage
    ogImage
    categories
    pageDefaults
    pageRules
    componentConfigs
    termsOfService
    cardShowPrice
    publicCardShowActionButton
    publicCardButtonLabel
    publicCardAction
    publicLandingPageButtonLabel
    membershipCardShowActionButton
    membershipCardWithAccessButtonLabel
    membershipCardWithAccessAction
    membershipCardNoAccessButtonLabel
    membershipCardNoAccessAction
    membershipLandingPageWithAccessButtonLabel
    membershipLandingPageNoAccessButtonLabel
    membershipLandingPageNoAccessMembershipAction
    commerceCardShowActionButton
    commerceCardNoAccessButtonLabel
    commerceCardNoAccessAction
    commerceCardWithAccessButtonLabel
    commerceCardWithAccessAction
    commerceLandingPageWithAccessButtonLabel
    commerceLandingPageNoAccessButtonLabel
    commerceLandingPageNoAccessAction
    primaryMembershipID
    membershipOfferPageID
    noAccessImage
    learningBoardGroupNames
    stylesheet
    tokens
    supportedLocales
    defaultCheckoutConfirmationMessage
    courseCardShowImage
    courseCardShowTitle
    courseCardShowInstructor
    courseCardShowDesc
    courseCardShowInfoBar
    courseCardShowActionButton
    courseCardShowLessonCount
    showCertification
    orderConfirmationEmailID
    newCustomerMembershipID
    showLearningBoard
    showUserNameInLearningBoard
    trackDeskTenantId
    cloudfrontDistributionID
    cloudfrontDistributionDomain
    deployedAt
    deployStatus
    googleAnalyticsTagID
    programLandingWithAccessCourseAction
    footerScripts
    repositoryOriginAccessIdentityID
    clientAIAnswerLength
    clientAIFeedbackButtons
    clientAIPromptPlaceholder
    clientAISuggestedPrompts
    clientAIPersistentPrompts
    clientAIPromptTemplate
    clientAIStartingMessage
    clientAIInlineReferences
    clientAISuggestRefinements
    clientAIAdditionalInstructions
    clientAIConfig
    learningBoardConfig
    addToCartEnabled
    productCardConfig
    aiSearchConfig
    clientAIBaseUrl
    showQuizResultsTab
    status
    purgeStatus
    purgeSteps
    purgeError
    __typename
  }
}
` as GeneratedQuery<APITypes.GetPortalQueryVariables, APITypes.GetPortalQuery>;
export const listPortals = /* GraphQL */ `query ListPortals(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelPortalFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listPortals(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      defaultLibraryID
      libraries
      libraryShares
      createdAt
      updatedAt
      name
      active
      publicName
      publicDomain
      sslDomain
      description
      type
      allowSearch
      enableInstructors
      requireSignature
      logoImage
      faviconImage
      ogImage
      categories
      pageDefaults
      pageRules
      componentConfigs
      termsOfService
      cardShowPrice
      publicCardShowActionButton
      publicCardButtonLabel
      publicCardAction
      publicLandingPageButtonLabel
      membershipCardShowActionButton
      membershipCardWithAccessButtonLabel
      membershipCardWithAccessAction
      membershipCardNoAccessButtonLabel
      membershipCardNoAccessAction
      membershipLandingPageWithAccessButtonLabel
      membershipLandingPageNoAccessButtonLabel
      membershipLandingPageNoAccessMembershipAction
      commerceCardShowActionButton
      commerceCardNoAccessButtonLabel
      commerceCardNoAccessAction
      commerceCardWithAccessButtonLabel
      commerceCardWithAccessAction
      commerceLandingPageWithAccessButtonLabel
      commerceLandingPageNoAccessButtonLabel
      commerceLandingPageNoAccessAction
      primaryMembershipID
      membershipOfferPageID
      noAccessImage
      learningBoardGroupNames
      stylesheet
      tokens
      supportedLocales
      defaultCheckoutConfirmationMessage
      courseCardShowImage
      courseCardShowTitle
      courseCardShowInstructor
      courseCardShowDesc
      courseCardShowInfoBar
      courseCardShowActionButton
      courseCardShowLessonCount
      showCertification
      orderConfirmationEmailID
      newCustomerMembershipID
      showLearningBoard
      showUserNameInLearningBoard
      trackDeskTenantId
      cloudfrontDistributionID
      cloudfrontDistributionDomain
      deployedAt
      deployStatus
      googleAnalyticsTagID
      programLandingWithAccessCourseAction
      footerScripts
      repositoryOriginAccessIdentityID
      clientAIAnswerLength
      clientAIFeedbackButtons
      clientAIPromptPlaceholder
      clientAISuggestedPrompts
      clientAIPersistentPrompts
      clientAIPromptTemplate
      clientAIStartingMessage
      clientAIInlineReferences
      clientAISuggestRefinements
      clientAIAdditionalInstructions
      clientAIConfig
      learningBoardConfig
      addToCartEnabled
      productCardConfig
      aiSearchConfig
      clientAIBaseUrl
      showQuizResultsTab
      status
      purgeStatus
      purgeSteps
      purgeError
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPortalsQueryVariables,
  APITypes.ListPortalsQuery
>;
export const getProgram = /* GraphQL */ `query GetProgram($organizationID: ID!, $id: ID!) {
  getProgram(organizationID: $organizationID, id: $id) {
    id
    organizationID
    slug
    manualSlug
    libraries
    createdAt
    updatedAt
    externalID
    name
    headline
    description
    objectives
    tags
    keywords
    level
    length
    sharePassword
    audience
    searchable
    gated
    requiredSkills
    startDate
    expiryDate
    confirmationMessage
    welcomeMessage
    congratulatoryMessage
    lessons
    enrollmentCount
    price
    sellPrice
    instructors
    reviews
    faqs
    currency
    discountPercent
    companyName
    certification
    active
    ctaUrl
    ctaLabel
    ctaNewWindow
    sections
    lessonCount
    courseCount
    programImage
    searchInstructors
    accessGroups
    excludeFromAllCourses
    courseItems
    microcastItems
    richText1
    richText2
    richText3
    richText4
    richText5
    richText6
    richText7
    richText8
    richText9
    richText10
    discussionTopic
    ogImage
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProgramQueryVariables,
  APITypes.GetProgramQuery
>;
export const listPrograms = /* GraphQL */ `query ListPrograms(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelProgramFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listPrograms(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      slug
      manualSlug
      libraries
      createdAt
      updatedAt
      externalID
      name
      headline
      description
      objectives
      tags
      keywords
      level
      length
      sharePassword
      audience
      searchable
      gated
      requiredSkills
      startDate
      expiryDate
      confirmationMessage
      welcomeMessage
      congratulatoryMessage
      lessons
      enrollmentCount
      price
      sellPrice
      instructors
      reviews
      faqs
      currency
      discountPercent
      companyName
      certification
      active
      ctaUrl
      ctaLabel
      ctaNewWindow
      sections
      lessonCount
      courseCount
      programImage
      searchInstructors
      accessGroups
      excludeFromAllCourses
      courseItems
      microcastItems
      richText1
      richText2
      richText3
      richText4
      richText5
      richText6
      richText7
      richText8
      richText9
      richText10
      discussionTopic
      ogImage
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProgramsQueryVariables,
  APITypes.ListProgramsQuery
>;
export const getProgramProgress = /* GraphQL */ `query GetProgramProgress(
  $organizationID: ID!
  $customerID: ID!
  $programID: ID!
  $id: ID!
) {
  getProgramProgress(
    organizationID: $organizationID
    customerID: $customerID
    programID: $programID
    id: $id
  ) {
    id
    organizationID
    customerID
    programID
    createdAt
    updatedAt
    progress
    startedDate
    completeDate
    lastActiveDate
    expiryDate
    sectionProgress
    lessonsCompleted
    quizResults
    notes
    courseItems
    hasCertification
    certificateAwarded
    certificates
    certifications
    completedCertifications
    certificateStatus
    certificateScore
    certificateAwardedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProgramProgressQueryVariables,
  APITypes.GetProgramProgressQuery
>;
export const listProgramProgresses = /* GraphQL */ `query ListProgramProgresses(
  $organizationID: ID
  $customerIDProgramIDId: ModelProgramProgressPrimaryCompositeKeyConditionInput
  $filter: ModelProgramProgressFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listProgramProgresses(
    organizationID: $organizationID
    customerIDProgramIDId: $customerIDProgramIDId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      customerID
      programID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      sectionProgress
      lessonsCompleted
      quizResults
      notes
      courseItems
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProgramProgressesQueryVariables,
  APITypes.ListProgramProgressesQuery
>;
export const programProgressByProgramIDCustomerID = /* GraphQL */ `query ProgramProgressByProgramIDCustomerID(
  $programID: ID
  $customerID: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProgramProgressFilterInput
  $limit: Int
  $nextToken: String
) {
  programProgressByProgramIDCustomerID(
    programID: $programID
    customerID: $customerID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      customerID
      programID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      sectionProgress
      lessonsCompleted
      quizResults
      notes
      courseItems
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProgramProgressByProgramIDCustomerIDQueryVariables,
  APITypes.ProgramProgressByProgramIDCustomerIDQuery
>;
export const getRepository = /* GraphQL */ `query GetRepository($organizationID: ID!, $id: ID!) {
  getRepository(organizationID: $organizationID, id: $id) {
    id
    organizationID
    createdAt
    updatedAt
    name
    description
    bucket
    cdnPath
    status
    cloudfrontDistributionDomain
    cloudfrontDistributionID
    cloudfrontOriginAccessIdentity
    deployedAt
    deployStatus
    signingKeyID
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRepositoryQueryVariables,
  APITypes.GetRepositoryQuery
>;
export const listRepositories = /* GraphQL */ `query ListRepositories(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelRepositoryFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listRepositories(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      createdAt
      updatedAt
      name
      description
      bucket
      cdnPath
      status
      cloudfrontDistributionDomain
      cloudfrontDistributionID
      cloudfrontOriginAccessIdentity
      deployedAt
      deployStatus
      signingKeyID
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRepositoriesQueryVariables,
  APITypes.ListRepositoriesQuery
>;
export const RepositoryByBucket = /* GraphQL */ `query RepositoryByBucket(
  $bucket: String
  $sortDirection: ModelSortDirection
  $filter: ModelRepositoryFilterInput
  $limit: Int
  $nextToken: String
) {
  RepositoryByBucket(
    bucket: $bucket
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      createdAt
      updatedAt
      name
      description
      bucket
      cdnPath
      status
      cloudfrontDistributionDomain
      cloudfrontDistributionID
      cloudfrontOriginAccessIdentity
      deployedAt
      deployStatus
      signingKeyID
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RepositoryByBucketQueryVariables,
  APITypes.RepositoryByBucketQuery
>;
export const getQuestionnaire = /* GraphQL */ `query GetQuestionnaire($organizationID: ID!, $id: ID!) {
  getQuestionnaire(organizationID: $organizationID, id: $id) {
    id
    organizationID
    portalID
    createdAt
    updatedAt
    startedAt
    completedAt
    name
    email
    welcomeMessage
    completionMessage
    status
    questions
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetQuestionnaireQueryVariables,
  APITypes.GetQuestionnaireQuery
>;
export const listQuestionnaires = /* GraphQL */ `query ListQuestionnaires(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelQuestionnaireFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listQuestionnaires(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      portalID
      createdAt
      updatedAt
      startedAt
      completedAt
      name
      email
      welcomeMessage
      completionMessage
      status
      questions
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListQuestionnairesQueryVariables,
  APITypes.ListQuestionnairesQuery
>;
export const listQuestionairesByEmail = /* GraphQL */ `query ListQuestionairesByEmail(
  $organizationID: ID
  $portalIDEmailStatus: ModelQuestionnaireByOrganizationEmailCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelQuestionnaireFilterInput
  $limit: Int
  $nextToken: String
) {
  listQuestionairesByEmail(
    organizationID: $organizationID
    portalIDEmailStatus: $portalIDEmailStatus
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      portalID
      createdAt
      updatedAt
      startedAt
      completedAt
      name
      email
      welcomeMessage
      completionMessage
      status
      questions
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListQuestionairesByEmailQueryVariables,
  APITypes.ListQuestionairesByEmailQuery
>;
export const getQuestion = /* GraphQL */ `query GetQuestion($organizationID: ID!, $id: ID!) {
  getQuestion(organizationID: $organizationID, id: $id) {
    id
    organizationID
    createdAt
    updatedAt
    name
    type
    availableAnswers
    selectedAnswers
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetQuestionQueryVariables,
  APITypes.GetQuestionQuery
>;
export const listQuestions = /* GraphQL */ `query ListQuestions(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelQuestionFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listQuestions(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      createdAt
      updatedAt
      name
      type
      availableAnswers
      selectedAnswers
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListQuestionsQueryVariables,
  APITypes.ListQuestionsQuery
>;
export const getShopifyConfig = /* GraphQL */ `query GetShopifyConfig($organizationID: ID!, $id: ID!) {
  getShopifyConfig(organizationID: $organizationID, id: $id) {
    id
    organizationID
    createdAt
    updatedAt
    name
    description
    shop
    storefrontDomain
    status
    clientAiKey
    productFeedEnabled
    indexCategories
    ignoreInventory
    ignoreOnlineStoreUrl
    productFeedStatus
    metafieldsConfig
    productTemplate
    titleTemplate
    parentTitleTemplate
    productActiveTemplate
    additionalProductDataCSV
    catalogTaxonomyAssetID
    productDescriptionOptimizationInstructions
    productDescriptionOptimizationMaxWords
    additionalProductDataConfig
    billingPlanType
    billingTier
    targetBillingTier
    merchantApprovedAmount
    customBillingAmount
    billingMessage
    installationDate
    subscriptionStart
    lastPaymentDate
    freePeriodExpiry
    contactName
    contactEmail
    contactPhone
    customizableTag
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetShopifyConfigQueryVariables,
  APITypes.GetShopifyConfigQuery
>;
export const listShopifyConfigs = /* GraphQL */ `query ListShopifyConfigs(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelShopifyConfigFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listShopifyConfigs(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      createdAt
      updatedAt
      name
      description
      shop
      storefrontDomain
      status
      clientAiKey
      productFeedEnabled
      indexCategories
      ignoreInventory
      ignoreOnlineStoreUrl
      productFeedStatus
      metafieldsConfig
      productTemplate
      titleTemplate
      parentTitleTemplate
      productActiveTemplate
      additionalProductDataCSV
      catalogTaxonomyAssetID
      productDescriptionOptimizationInstructions
      productDescriptionOptimizationMaxWords
      additionalProductDataConfig
      billingPlanType
      billingTier
      targetBillingTier
      merchantApprovedAmount
      customBillingAmount
      billingMessage
      installationDate
      subscriptionStart
      lastPaymentDate
      freePeriodExpiry
      contactName
      contactEmail
      contactPhone
      customizableTag
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListShopifyConfigsQueryVariables,
  APITypes.ListShopifyConfigsQuery
>;
export const ByShop = /* GraphQL */ `query ByShop(
  $shop: String
  $status: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelShopifyConfigFilterInput
  $limit: Int
  $nextToken: String
) {
  ByShop(
    shop: $shop
    status: $status
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      createdAt
      updatedAt
      name
      description
      shop
      storefrontDomain
      status
      clientAiKey
      productFeedEnabled
      indexCategories
      ignoreInventory
      ignoreOnlineStoreUrl
      productFeedStatus
      metafieldsConfig
      productTemplate
      titleTemplate
      parentTitleTemplate
      productActiveTemplate
      additionalProductDataCSV
      catalogTaxonomyAssetID
      productDescriptionOptimizationInstructions
      productDescriptionOptimizationMaxWords
      additionalProductDataConfig
      billingPlanType
      billingTier
      targetBillingTier
      merchantApprovedAmount
      customBillingAmount
      billingMessage
      installationDate
      subscriptionStart
      lastPaymentDate
      freePeriodExpiry
      contactName
      contactEmail
      contactPhone
      customizableTag
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ByShopQueryVariables, APITypes.ByShopQuery>;
export const getProduct = /* GraphQL */ `query GetProduct($organizationID: ID!, $id: ID!) {
  getProduct(organizationID: $organizationID, id: $id) {
    id
    organizationID
    syncConfigID
    handle
    name
    bodyHtml
    vendor
    productType
    imageSrc
    url
    tags
    status
    optionTypes
    productData
    catalogCategorization
    attributes
    productSheet
    externalIDs
    variants
    relatedGuideIds
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProductQueryVariables,
  APITypes.GetProductQuery
>;
export const listProducts = /* GraphQL */ `query ListProducts(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelProductFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listProducts(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      syncConfigID
      handle
      name
      bodyHtml
      vendor
      productType
      imageSrc
      url
      tags
      status
      optionTypes
      productData
      catalogCategorization
      attributes
      productSheet
      externalIDs
      variants
      relatedGuideIds
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProductsQueryVariables,
  APITypes.ListProductsQuery
>;
export const listProductsBySyncConfig = /* GraphQL */ `query ListProductsBySyncConfig(
  $organizationID: ID
  $syncConfigID: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductFilterInput
  $limit: Int
  $nextToken: String
) {
  listProductsBySyncConfig(
    organizationID: $organizationID
    syncConfigID: $syncConfigID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      syncConfigID
      handle
      name
      bodyHtml
      vendor
      productType
      imageSrc
      url
      tags
      status
      optionTypes
      productData
      catalogCategorization
      attributes
      productSheet
      externalIDs
      variants
      relatedGuideIds
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProductsBySyncConfigQueryVariables,
  APITypes.ListProductsBySyncConfigQuery
>;
export const getWebPage = /* GraphQL */ `query GetWebPage($organizationID: ID!, $id: ID!) {
  getWebPage(organizationID: $organizationID, id: $id) {
    id
    organizationID
    crawlID
    url
    name
    description
    pageMarkdown
    screenshotKey
    pageData
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetWebPageQueryVariables,
  APITypes.GetWebPageQuery
>;
export const listWebPages = /* GraphQL */ `query ListWebPages(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelWebPageFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listWebPages(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      crawlID
      url
      name
      description
      pageMarkdown
      screenshotKey
      pageData
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListWebPagesQueryVariables,
  APITypes.ListWebPagesQuery
>;
export const listWebPagesByCrawl = /* GraphQL */ `query ListWebPagesByCrawl(
  $organizationID: ID
  $crawlID: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelWebPageFilterInput
  $limit: Int
  $nextToken: String
) {
  listWebPagesByCrawl(
    organizationID: $organizationID
    crawlID: $crawlID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      crawlID
      url
      name
      description
      pageMarkdown
      screenshotKey
      pageData
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListWebPagesByCrawlQueryVariables,
  APITypes.ListWebPagesByCrawlQuery
>;
export const getCategory = /* GraphQL */ `query GetCategory($organizationID: ID!, $id: ID!) {
  getCategory(organizationID: $organizationID, id: $id) {
    id
    organizationID
    syncConfigID
    handle
    name
    descriptionHtml
    imageUrl
    productCount
    relatedGuideIds
    categoryData
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCategoryQueryVariables,
  APITypes.GetCategoryQuery
>;
export const listCategories = /* GraphQL */ `query ListCategories(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelCategoryFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCategories(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      syncConfigID
      handle
      name
      descriptionHtml
      imageUrl
      productCount
      relatedGuideIds
      categoryData
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCategoriesQueryVariables,
  APITypes.ListCategoriesQuery
>;
export const listCategoriesBySyncConfig = /* GraphQL */ `query ListCategoriesBySyncConfig(
  $organizationID: ID
  $syncConfigID: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCategoryFilterInput
  $limit: Int
  $nextToken: String
) {
  listCategoriesBySyncConfig(
    organizationID: $organizationID
    syncConfigID: $syncConfigID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      syncConfigID
      handle
      name
      descriptionHtml
      imageUrl
      productCount
      relatedGuideIds
      categoryData
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCategoriesBySyncConfigQueryVariables,
  APITypes.ListCategoriesBySyncConfigQuery
>;
export const getGuideCluster = /* GraphQL */ `query GetGuideCluster($organizationID: ID!, $id: ID!) {
  getGuideCluster(organizationID: $organizationID, id: $id) {
    id
    organizationID
    recordType
    portalID
    syncConfigID
    name
    description
    strategyTags
    discoverySourceUrl
    externalKey
    coreGuideId
    parentJobId
    refinementRound
    openAiResponseId
    sourceUrl
    strategyLevel
    additionalInstructions
    lastRefinementNotes
    resultJson
    errorMessage
    status
    proposalJobId
    entityType
    changeType
    targetId
    currentJson
    proposedJson
    reason
    sortOrder
    reviewStatus
    sourceSignals
    clusterConfidence
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetGuideClusterQueryVariables,
  APITypes.GetGuideClusterQuery
>;
export const listGuideClusters = /* GraphQL */ `query ListGuideClusters(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelGuideClusterFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listGuideClusters(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      recordType
      portalID
      syncConfigID
      name
      description
      strategyTags
      discoverySourceUrl
      externalKey
      coreGuideId
      parentJobId
      refinementRound
      openAiResponseId
      sourceUrl
      strategyLevel
      additionalInstructions
      lastRefinementNotes
      resultJson
      errorMessage
      status
      proposalJobId
      entityType
      changeType
      targetId
      currentJson
      proposedJson
      reason
      sortOrder
      reviewStatus
      sourceSignals
      clusterConfidence
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListGuideClustersQueryVariables,
  APITypes.ListGuideClustersQuery
>;
export const listGuideClustersBySyncConfig = /* GraphQL */ `query ListGuideClustersBySyncConfig(
  $organizationID: ID
  $syncConfigID: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelGuideClusterFilterInput
  $limit: Int
  $nextToken: String
) {
  listGuideClustersBySyncConfig(
    organizationID: $organizationID
    syncConfigID: $syncConfigID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      recordType
      portalID
      syncConfigID
      name
      description
      strategyTags
      discoverySourceUrl
      externalKey
      coreGuideId
      parentJobId
      refinementRound
      openAiResponseId
      sourceUrl
      strategyLevel
      additionalInstructions
      lastRefinementNotes
      resultJson
      errorMessage
      status
      proposalJobId
      entityType
      changeType
      targetId
      currentJson
      proposedJson
      reason
      sortOrder
      reviewStatus
      sourceSignals
      clusterConfidence
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListGuideClustersBySyncConfigQueryVariables,
  APITypes.ListGuideClustersBySyncConfigQuery
>;
export const listGuideClustersByProposalJob = /* GraphQL */ `query ListGuideClustersByProposalJob(
  $organizationID: ID
  $proposalJobId: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelGuideClusterFilterInput
  $limit: Int
  $nextToken: String
) {
  listGuideClustersByProposalJob(
    organizationID: $organizationID
    proposalJobId: $proposalJobId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      recordType
      portalID
      syncConfigID
      name
      description
      strategyTags
      discoverySourceUrl
      externalKey
      coreGuideId
      parentJobId
      refinementRound
      openAiResponseId
      sourceUrl
      strategyLevel
      additionalInstructions
      lastRefinementNotes
      resultJson
      errorMessage
      status
      proposalJobId
      entityType
      changeType
      targetId
      currentJson
      proposedJson
      reason
      sortOrder
      reviewStatus
      sourceSignals
      clusterConfidence
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListGuideClustersByProposalJobQueryVariables,
  APITypes.ListGuideClustersByProposalJobQuery
>;
export const getGuide = /* GraphQL */ `query GetGuide($organizationID: ID!, $id: ID!) {
  getGuide(organizationID: $organizationID, id: $id) {
    id
    organizationID
    portalID
    syncConfigID
    guideClusterID
    guideType
    role
    targetPrompts
    intentDescription
    title
    slug
    excerpt
    keywords
    relatedGuideIds
    bylineInstructorID
    reviewerInstructorID
    metaTitle
    metaDescription
    guideImageAssetID
    guideImageUrl
    guideImageAltText
    guideImageSource
    guideImagePrompt
    content
    status
    sourceUrl
    topic
    generationStatus
    generationErrorMessage
    generationFailureId
    generationFailurePhase
    publishStatus
    publishGateStatus
    shopifyBlogId
    shopifyBlogHandle
    shopifyArticleId
    shopifyArticleHandle
    shopifyArticleUrl
    shopifyArticleTemplateSuffix
    lastPublishAttemptAt
    lastPublishOperation
    lastPublishErrorMessage
    shopifyUrlSource
    publishVerificationStatus
    lastPublishResponse
    publishedAt
    lastGeneratedAt
    lastPublishedAt
    suggestedProductHandles
    approvalStatus
    approvalNote
    generationSource
    syncStatus
    lastSyncedAt
    createdAt
    updatedAt
    publishedVersionId
    currentDraftVersionId
    currentChangeSetId
    livePublishedAt
    deletedAt
    guideScore
    guideScoreBreakdown
    lastScoredAt
    guideScoreFingerprint
    commerce
    __typename
  }
}
` as GeneratedQuery<APITypes.GetGuideQueryVariables, APITypes.GetGuideQuery>;
export const listGuides = /* GraphQL */ `query ListGuides(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelGuideFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listGuides(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      portalID
      syncConfigID
      guideClusterID
      guideType
      role
      targetPrompts
      intentDescription
      title
      slug
      excerpt
      keywords
      relatedGuideIds
      bylineInstructorID
      reviewerInstructorID
      metaTitle
      metaDescription
      guideImageAssetID
      guideImageUrl
      guideImageAltText
      guideImageSource
      guideImagePrompt
      content
      status
      sourceUrl
      topic
      generationStatus
      generationErrorMessage
      generationFailureId
      generationFailurePhase
      publishStatus
      publishGateStatus
      shopifyBlogId
      shopifyBlogHandle
      shopifyArticleId
      shopifyArticleHandle
      shopifyArticleUrl
      shopifyArticleTemplateSuffix
      lastPublishAttemptAt
      lastPublishOperation
      lastPublishErrorMessage
      shopifyUrlSource
      publishVerificationStatus
      lastPublishResponse
      publishedAt
      lastGeneratedAt
      lastPublishedAt
      suggestedProductHandles
      approvalStatus
      approvalNote
      generationSource
      syncStatus
      lastSyncedAt
      createdAt
      updatedAt
      publishedVersionId
      currentDraftVersionId
      currentChangeSetId
      livePublishedAt
      deletedAt
      guideScore
      guideScoreBreakdown
      lastScoredAt
      guideScoreFingerprint
      commerce
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListGuidesQueryVariables,
  APITypes.ListGuidesQuery
>;
export const listGuidesBySyncConfig = /* GraphQL */ `query ListGuidesBySyncConfig(
  $organizationID: ID
  $syncConfigID: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelGuideFilterInput
  $limit: Int
  $nextToken: String
) {
  listGuidesBySyncConfig(
    organizationID: $organizationID
    syncConfigID: $syncConfigID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      portalID
      syncConfigID
      guideClusterID
      guideType
      role
      targetPrompts
      intentDescription
      title
      slug
      excerpt
      keywords
      relatedGuideIds
      bylineInstructorID
      reviewerInstructorID
      metaTitle
      metaDescription
      guideImageAssetID
      guideImageUrl
      guideImageAltText
      guideImageSource
      guideImagePrompt
      content
      status
      sourceUrl
      topic
      generationStatus
      generationErrorMessage
      generationFailureId
      generationFailurePhase
      publishStatus
      publishGateStatus
      shopifyBlogId
      shopifyBlogHandle
      shopifyArticleId
      shopifyArticleHandle
      shopifyArticleUrl
      shopifyArticleTemplateSuffix
      lastPublishAttemptAt
      lastPublishOperation
      lastPublishErrorMessage
      shopifyUrlSource
      publishVerificationStatus
      lastPublishResponse
      publishedAt
      lastGeneratedAt
      lastPublishedAt
      suggestedProductHandles
      approvalStatus
      approvalNote
      generationSource
      syncStatus
      lastSyncedAt
      createdAt
      updatedAt
      publishedVersionId
      currentDraftVersionId
      currentChangeSetId
      livePublishedAt
      deletedAt
      guideScore
      guideScoreBreakdown
      lastScoredAt
      guideScoreFingerprint
      commerce
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListGuidesBySyncConfigQueryVariables,
  APITypes.ListGuidesBySyncConfigQuery
>;
export const listGuidesByGuideCluster = /* GraphQL */ `query ListGuidesByGuideCluster(
  $organizationID: ID
  $guideClusterID: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelGuideFilterInput
  $limit: Int
  $nextToken: String
) {
  listGuidesByGuideCluster(
    organizationID: $organizationID
    guideClusterID: $guideClusterID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      portalID
      syncConfigID
      guideClusterID
      guideType
      role
      targetPrompts
      intentDescription
      title
      slug
      excerpt
      keywords
      relatedGuideIds
      bylineInstructorID
      reviewerInstructorID
      metaTitle
      metaDescription
      guideImageAssetID
      guideImageUrl
      guideImageAltText
      guideImageSource
      guideImagePrompt
      content
      status
      sourceUrl
      topic
      generationStatus
      generationErrorMessage
      generationFailureId
      generationFailurePhase
      publishStatus
      publishGateStatus
      shopifyBlogId
      shopifyBlogHandle
      shopifyArticleId
      shopifyArticleHandle
      shopifyArticleUrl
      shopifyArticleTemplateSuffix
      lastPublishAttemptAt
      lastPublishOperation
      lastPublishErrorMessage
      shopifyUrlSource
      publishVerificationStatus
      lastPublishResponse
      publishedAt
      lastGeneratedAt
      lastPublishedAt
      suggestedProductHandles
      approvalStatus
      approvalNote
      generationSource
      syncStatus
      lastSyncedAt
      createdAt
      updatedAt
      publishedVersionId
      currentDraftVersionId
      currentChangeSetId
      livePublishedAt
      deletedAt
      guideScore
      guideScoreBreakdown
      lastScoredAt
      guideScoreFingerprint
      commerce
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListGuidesByGuideClusterQueryVariables,
  APITypes.ListGuidesByGuideClusterQuery
>;
export const listGuidesByClusterAndRole = /* GraphQL */ `query ListGuidesByClusterAndRole(
  $guideClusterID: ID
  $role: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelGuideFilterInput
  $limit: Int
  $nextToken: String
) {
  listGuidesByClusterAndRole(
    guideClusterID: $guideClusterID
    role: $role
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      portalID
      syncConfigID
      guideClusterID
      guideType
      role
      targetPrompts
      intentDescription
      title
      slug
      excerpt
      keywords
      relatedGuideIds
      bylineInstructorID
      reviewerInstructorID
      metaTitle
      metaDescription
      guideImageAssetID
      guideImageUrl
      guideImageAltText
      guideImageSource
      guideImagePrompt
      content
      status
      sourceUrl
      topic
      generationStatus
      generationErrorMessage
      generationFailureId
      generationFailurePhase
      publishStatus
      publishGateStatus
      shopifyBlogId
      shopifyBlogHandle
      shopifyArticleId
      shopifyArticleHandle
      shopifyArticleUrl
      shopifyArticleTemplateSuffix
      lastPublishAttemptAt
      lastPublishOperation
      lastPublishErrorMessage
      shopifyUrlSource
      publishVerificationStatus
      lastPublishResponse
      publishedAt
      lastGeneratedAt
      lastPublishedAt
      suggestedProductHandles
      approvalStatus
      approvalNote
      generationSource
      syncStatus
      lastSyncedAt
      createdAt
      updatedAt
      publishedVersionId
      currentDraftVersionId
      currentChangeSetId
      livePublishedAt
      deletedAt
      guideScore
      guideScoreBreakdown
      lastScoredAt
      guideScoreFingerprint
      commerce
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListGuidesByClusterAndRoleQueryVariables,
  APITypes.ListGuidesByClusterAndRoleQuery
>;
export const listPublishedGuidesByPortal = /* GraphQL */ `query ListPublishedGuidesByPortal(
  $portalID: ID
  $livePublishedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelGuideFilterInput
  $limit: Int
  $nextToken: String
) {
  listPublishedGuidesByPortal(
    portalID: $portalID
    livePublishedAt: $livePublishedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      portalID
      syncConfigID
      guideClusterID
      guideType
      role
      targetPrompts
      intentDescription
      title
      slug
      excerpt
      keywords
      relatedGuideIds
      bylineInstructorID
      reviewerInstructorID
      metaTitle
      metaDescription
      guideImageAssetID
      guideImageUrl
      guideImageAltText
      guideImageSource
      guideImagePrompt
      content
      status
      sourceUrl
      topic
      generationStatus
      generationErrorMessage
      generationFailureId
      generationFailurePhase
      publishStatus
      publishGateStatus
      shopifyBlogId
      shopifyBlogHandle
      shopifyArticleId
      shopifyArticleHandle
      shopifyArticleUrl
      shopifyArticleTemplateSuffix
      lastPublishAttemptAt
      lastPublishOperation
      lastPublishErrorMessage
      shopifyUrlSource
      publishVerificationStatus
      lastPublishResponse
      publishedAt
      lastGeneratedAt
      lastPublishedAt
      suggestedProductHandles
      approvalStatus
      approvalNote
      generationSource
      syncStatus
      lastSyncedAt
      createdAt
      updatedAt
      publishedVersionId
      currentDraftVersionId
      currentChangeSetId
      livePublishedAt
      deletedAt
      guideScore
      guideScoreBreakdown
      lastScoredAt
      guideScoreFingerprint
      commerce
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPublishedGuidesByPortalQueryVariables,
  APITypes.ListPublishedGuidesByPortalQuery
>;
export const getCourseAlertConfig = /* GraphQL */ `query GetCourseAlertConfig($organizationID: ID!, $courseID: ID!) {
  getCourseAlertConfig(organizationID: $organizationID, courseID: $courseID) {
    organizationID
    courseID
    alertsEmail
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCourseAlertConfigQueryVariables,
  APITypes.GetCourseAlertConfigQuery
>;
export const listCourseAlertConfigs = /* GraphQL */ `query ListCourseAlertConfigs(
  $organizationID: ID
  $courseID: ModelIDKeyConditionInput
  $filter: ModelCourseAlertConfigFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCourseAlertConfigs(
    organizationID: $organizationID
    courseID: $courseID
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      organizationID
      courseID
      alertsEmail
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCourseAlertConfigsQueryVariables,
  APITypes.ListCourseAlertConfigsQuery
>;
export const getGeoConfiguration = /* GraphQL */ `query GetGeoConfiguration($organizationID: ID!, $id: ID!) {
  getGeoConfiguration(organizationID: $organizationID, id: $id) {
    id
    organizationID
    portalID
    activeChangeSetId
    marketCountry
    marketLocale
    marketCurrency
    siteUrl
    brandDescription
    audience
    voiceTone
    avoidGuidance
    complianceRules
    vertical
    competitorUrls
    brandName
    brandAliases
    competitors
    defaultStrategyLevel
    defaultPlanScope
    planAdditionalInstructions
    topicsPromptOverride
    contentPromptOverride
    guideLengthPreference
    guideStructureNotes
    imageStyleNotes
    imageComplianceNotes
    imageGenerationPromptOverride
    defaultBlogHandle
    defaultArticleTemplateSuffix
    publishWorkflow
    publishAdapter
    allowedSourceDomains
    ugcDomains
    mustNotContainPatterns
    onboardingComplete
    guideCommerce
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetGeoConfigurationQueryVariables,
  APITypes.GetGeoConfigurationQuery
>;
export const listGeoConfigurations = /* GraphQL */ `query ListGeoConfigurations(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelGeoConfigurationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listGeoConfigurations(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      portalID
      activeChangeSetId
      marketCountry
      marketLocale
      marketCurrency
      siteUrl
      brandDescription
      audience
      voiceTone
      avoidGuidance
      complianceRules
      vertical
      competitorUrls
      brandName
      brandAliases
      competitors
      defaultStrategyLevel
      defaultPlanScope
      planAdditionalInstructions
      topicsPromptOverride
      contentPromptOverride
      guideLengthPreference
      guideStructureNotes
      imageStyleNotes
      imageComplianceNotes
      imageGenerationPromptOverride
      defaultBlogHandle
      defaultArticleTemplateSuffix
      publishWorkflow
      publishAdapter
      allowedSourceDomains
      ugcDomains
      mustNotContainPatterns
      onboardingComplete
      guideCommerce
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListGeoConfigurationsQueryVariables,
  APITypes.ListGeoConfigurationsQuery
>;
export const geoConfigByPortal = /* GraphQL */ `query GeoConfigByPortal(
  $organizationID: ID
  $portalID: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelGeoConfigurationFilterInput
  $limit: Int
  $nextToken: String
) {
  geoConfigByPortal(
    organizationID: $organizationID
    portalID: $portalID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      portalID
      activeChangeSetId
      marketCountry
      marketLocale
      marketCurrency
      siteUrl
      brandDescription
      audience
      voiceTone
      avoidGuidance
      complianceRules
      vertical
      competitorUrls
      brandName
      brandAliases
      competitors
      defaultStrategyLevel
      defaultPlanScope
      planAdditionalInstructions
      topicsPromptOverride
      contentPromptOverride
      guideLengthPreference
      guideStructureNotes
      imageStyleNotes
      imageComplianceNotes
      imageGenerationPromptOverride
      defaultBlogHandle
      defaultArticleTemplateSuffix
      publishWorkflow
      publishAdapter
      allowedSourceDomains
      ugcDomains
      mustNotContainPatterns
      onboardingComplete
      guideCommerce
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GeoConfigByPortalQueryVariables,
  APITypes.GeoConfigByPortalQuery
>;
export const getTrackedPrompt = /* GraphQL */ `query GetTrackedPrompt($organizationID: ID!, $id: ID!) {
  getTrackedPrompt(organizationID: $organizationID, id: $id) {
    id
    organizationID
    portalID
    text
    clusterID
    clusterProposed
    intentID
    intentProposed
    status
    hasGuide
    lastScannedAt
    retiredAt
    brandScope
    brandTerm
    brandScopeSource
    latestVisibilityScore
    latestBrandMentioned
    latestEngineBreakdown
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTrackedPromptQueryVariables,
  APITypes.GetTrackedPromptQuery
>;
export const listTrackedPrompts = /* GraphQL */ `query ListTrackedPrompts(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelTrackedPromptFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listTrackedPrompts(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      portalID
      text
      clusterID
      clusterProposed
      intentID
      intentProposed
      status
      hasGuide
      lastScannedAt
      retiredAt
      brandScope
      brandTerm
      brandScopeSource
      latestVisibilityScore
      latestBrandMentioned
      latestEngineBreakdown
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTrackedPromptsQueryVariables,
  APITypes.ListTrackedPromptsQuery
>;
export const listTrackedPromptsByOrgPortal = /* GraphQL */ `query ListTrackedPromptsByOrgPortal(
  $organizationID: ID
  $portalID: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTrackedPromptFilterInput
  $limit: Int
  $nextToken: String
) {
  listTrackedPromptsByOrgPortal(
    organizationID: $organizationID
    portalID: $portalID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      portalID
      text
      clusterID
      clusterProposed
      intentID
      intentProposed
      status
      hasGuide
      lastScannedAt
      retiredAt
      brandScope
      brandTerm
      brandScopeSource
      latestVisibilityScore
      latestBrandMentioned
      latestEngineBreakdown
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTrackedPromptsByOrgPortalQueryVariables,
  APITypes.ListTrackedPromptsByOrgPortalQuery
>;
export const listTrackedPromptsByCluster = /* GraphQL */ `query ListTrackedPromptsByCluster(
  $organizationID: ID
  $clusterID: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTrackedPromptFilterInput
  $limit: Int
  $nextToken: String
) {
  listTrackedPromptsByCluster(
    organizationID: $organizationID
    clusterID: $clusterID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      portalID
      text
      clusterID
      clusterProposed
      intentID
      intentProposed
      status
      hasGuide
      lastScannedAt
      retiredAt
      brandScope
      brandTerm
      brandScopeSource
      latestVisibilityScore
      latestBrandMentioned
      latestEngineBreakdown
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTrackedPromptsByClusterQueryVariables,
  APITypes.ListTrackedPromptsByClusterQuery
>;
export const getCustomerIntent = /* GraphQL */ `query GetCustomerIntent($organizationID: ID!, $id: ID!) {
  getCustomerIntent(organizationID: $organizationID, id: $id) {
    id
    organizationID
    portalID
    name
    rationale
    stage
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCustomerIntentQueryVariables,
  APITypes.GetCustomerIntentQuery
>;
export const listCustomerIntents = /* GraphQL */ `query ListCustomerIntents(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelCustomerIntentFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCustomerIntents(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      portalID
      name
      rationale
      stage
      status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCustomerIntentsQueryVariables,
  APITypes.ListCustomerIntentsQuery
>;
export const listCustomerIntentsByOrgPortal = /* GraphQL */ `query ListCustomerIntentsByOrgPortal(
  $organizationID: ID
  $portalID: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCustomerIntentFilterInput
  $limit: Int
  $nextToken: String
) {
  listCustomerIntentsByOrgPortal(
    organizationID: $organizationID
    portalID: $portalID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      portalID
      name
      rationale
      stage
      status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCustomerIntentsByOrgPortalQueryVariables,
  APITypes.ListCustomerIntentsByOrgPortalQuery
>;
export const getContentSource = /* GraphQL */ `query GetContentSource($organizationID: ID!, $id: ID!) {
  getContentSource(organizationID: $organizationID, id: $id) {
    id
    organizationID
    portalID
    sourceType
    sourceSubtype
    ingestMethod
    status
    recordCount
    processedAt
    metadata
    taskId
    errorMessage
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetContentSourceQueryVariables,
  APITypes.GetContentSourceQuery
>;
export const listContentSources = /* GraphQL */ `query ListContentSources(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelContentSourceFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listContentSources(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      portalID
      sourceType
      sourceSubtype
      ingestMethod
      status
      recordCount
      processedAt
      metadata
      taskId
      errorMessage
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListContentSourcesQueryVariables,
  APITypes.ListContentSourcesQuery
>;
export const listContentSourcesByOrgPortal = /* GraphQL */ `query ListContentSourcesByOrgPortal(
  $organizationID: ID
  $portalID: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelContentSourceFilterInput
  $limit: Int
  $nextToken: String
) {
  listContentSourcesByOrgPortal(
    organizationID: $organizationID
    portalID: $portalID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      portalID
      sourceType
      sourceSubtype
      ingestMethod
      status
      recordCount
      processedAt
      metadata
      taskId
      errorMessage
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListContentSourcesByOrgPortalQueryVariables,
  APITypes.ListContentSourcesByOrgPortalQuery
>;
export const listContentSourcesByOrgType = /* GraphQL */ `query ListContentSourcesByOrgType(
  $organizationID: ID
  $sourceType: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelContentSourceFilterInput
  $limit: Int
  $nextToken: String
) {
  listContentSourcesByOrgType(
    organizationID: $organizationID
    sourceType: $sourceType
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      portalID
      sourceType
      sourceSubtype
      ingestMethod
      status
      recordCount
      processedAt
      metadata
      taskId
      errorMessage
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListContentSourcesByOrgTypeQueryVariables,
  APITypes.ListContentSourcesByOrgTypeQuery
>;
export const getExtractedTopic = /* GraphQL */ `query GetExtractedTopic($organizationID: ID!, $id: ID!) {
  getExtractedTopic(organizationID: $organizationID, id: $id) {
    id
    organizationID
    portalID
    contentSourceId
    topic
    rawText
    frequency
    confidence
    status
    assignedClusterID
    metadata
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetExtractedTopicQueryVariables,
  APITypes.GetExtractedTopicQuery
>;
export const listExtractedTopics = /* GraphQL */ `query ListExtractedTopics(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelExtractedTopicFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listExtractedTopics(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      portalID
      contentSourceId
      topic
      rawText
      frequency
      confidence
      status
      assignedClusterID
      metadata
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListExtractedTopicsQueryVariables,
  APITypes.ListExtractedTopicsQuery
>;
export const listExtractedTopicsByContentSource = /* GraphQL */ `query ListExtractedTopicsByContentSource(
  $organizationID: ID
  $contentSourceId: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelExtractedTopicFilterInput
  $limit: Int
  $nextToken: String
) {
  listExtractedTopicsByContentSource(
    organizationID: $organizationID
    contentSourceId: $contentSourceId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      portalID
      contentSourceId
      topic
      rawText
      frequency
      confidence
      status
      assignedClusterID
      metadata
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListExtractedTopicsByContentSourceQueryVariables,
  APITypes.ListExtractedTopicsByContentSourceQuery
>;
export const listExtractedTopicsByOrgStatus = /* GraphQL */ `query ListExtractedTopicsByOrgStatus(
  $organizationID: ID
  $status: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelExtractedTopicFilterInput
  $limit: Int
  $nextToken: String
) {
  listExtractedTopicsByOrgStatus(
    organizationID: $organizationID
    status: $status
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      portalID
      contentSourceId
      topic
      rawText
      frequency
      confidence
      status
      assignedClusterID
      metadata
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListExtractedTopicsByOrgStatusQueryVariables,
  APITypes.ListExtractedTopicsByOrgStatusQuery
>;
export const getGeoScoreSnapshot = /* GraphQL */ `query GetGeoScoreSnapshot($organizationID: ID!, $id: ID!) {
  getGeoScoreSnapshot(organizationID: $organizationID, id: $id) {
    id
    organizationID
    seriesKey
    scope
    entityId
    date
    score
    subscores
    source
    capturedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetGeoScoreSnapshotQueryVariables,
  APITypes.GetGeoScoreSnapshotQuery
>;
export const listGeoScoreSnapshots = /* GraphQL */ `query ListGeoScoreSnapshots(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelGeoScoreSnapshotFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listGeoScoreSnapshots(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      seriesKey
      scope
      entityId
      date
      score
      subscores
      source
      capturedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListGeoScoreSnapshotsQueryVariables,
  APITypes.ListGeoScoreSnapshotsQuery
>;
export const listGeoScoreSnapshotsBySeries = /* GraphQL */ `query ListGeoScoreSnapshotsBySeries(
  $seriesKey: String
  $date: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelGeoScoreSnapshotFilterInput
  $limit: Int
  $nextToken: String
) {
  listGeoScoreSnapshotsBySeries(
    seriesKey: $seriesKey
    date: $date
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      seriesKey
      scope
      entityId
      date
      score
      subscores
      source
      capturedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListGeoScoreSnapshotsBySeriesQueryVariables,
  APITypes.ListGeoScoreSnapshotsBySeriesQuery
>;
export const getVisibilityScan = /* GraphQL */ `query GetVisibilityScan($organizationID: ID!, $id: ID!) {
  getVisibilityScan(organizationID: $organizationID, id: $id) {
    id
    organizationID
    portalID
    marketCountry
    localizationMethod
    trackedPromptID
    promptText
    engine
    scannedAt
    rawResponse
    brandMentioned
    brandMentionedRegex
    brandMentionCount
    brandPosition
    brandContext
    competitorMentions
    citations
    visibilityScore
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetVisibilityScanQueryVariables,
  APITypes.GetVisibilityScanQuery
>;
export const listVisibilityScans = /* GraphQL */ `query ListVisibilityScans(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelVisibilityScanFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listVisibilityScans(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      portalID
      marketCountry
      localizationMethod
      trackedPromptID
      promptText
      engine
      scannedAt
      rawResponse
      brandMentioned
      brandMentionedRegex
      brandMentionCount
      brandPosition
      brandContext
      competitorMentions
      citations
      visibilityScore
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListVisibilityScansQueryVariables,
  APITypes.ListVisibilityScansQuery
>;
export const listVisibilityScansByTrackedPrompt = /* GraphQL */ `query ListVisibilityScansByTrackedPrompt(
  $trackedPromptID: ID
  $scannedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelVisibilityScanFilterInput
  $limit: Int
  $nextToken: String
) {
  listVisibilityScansByTrackedPrompt(
    trackedPromptID: $trackedPromptID
    scannedAt: $scannedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      portalID
      marketCountry
      localizationMethod
      trackedPromptID
      promptText
      engine
      scannedAt
      rawResponse
      brandMentioned
      brandMentionedRegex
      brandMentionCount
      brandPosition
      brandContext
      competitorMentions
      citations
      visibilityScore
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListVisibilityScansByTrackedPromptQueryVariables,
  APITypes.ListVisibilityScansByTrackedPromptQuery
>;
export const listVisibilityScansByOrgPortal = /* GraphQL */ `query ListVisibilityScansByOrgPortal(
  $organizationID: ID
  $portalID: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelVisibilityScanFilterInput
  $limit: Int
  $nextToken: String
) {
  listVisibilityScansByOrgPortal(
    organizationID: $organizationID
    portalID: $portalID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      portalID
      marketCountry
      localizationMethod
      trackedPromptID
      promptText
      engine
      scannedAt
      rawResponse
      brandMentioned
      brandMentionedRegex
      brandMentionCount
      brandPosition
      brandContext
      competitorMentions
      citations
      visibilityScore
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListVisibilityScansByOrgPortalQueryVariables,
  APITypes.ListVisibilityScansByOrgPortalQuery
>;
export const getAdminEvent = /* GraphQL */ `query GetAdminEvent($organizationID: ID!, $id: ID!) {
  getAdminEvent(organizationID: $organizationID, id: $id) {
    id
    organizationID
    portalID
    eventType
    source
    message
    iconHint
    taskId
    relatedEntityType
    relatedEntityId
    ttl
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAdminEventQueryVariables,
  APITypes.GetAdminEventQuery
>;
export const listAdminEvents = /* GraphQL */ `query ListAdminEvents(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelAdminEventFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAdminEvents(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      portalID
      eventType
      source
      message
      iconHint
      taskId
      relatedEntityType
      relatedEntityId
      ttl
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAdminEventsQueryVariables,
  APITypes.ListAdminEventsQuery
>;
export const listAdminEventsByOrg = /* GraphQL */ `query ListAdminEventsByOrg(
  $organizationID: ID
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAdminEventFilterInput
  $limit: Int
  $nextToken: String
) {
  listAdminEventsByOrg(
    organizationID: $organizationID
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      portalID
      eventType
      source
      message
      iconHint
      taskId
      relatedEntityType
      relatedEntityId
      ttl
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAdminEventsByOrgQueryVariables,
  APITypes.ListAdminEventsByOrgQuery
>;
export const getChangeAudit = /* GraphQL */ `query GetChangeAudit($organizationID: ID!, $id: ID!) {
  getChangeAudit(organizationID: $organizationID, id: $id) {
    id
    organizationID
    portalID
    entityType
    entityId
    operation
    channel
    actorId
    changedFields
    changes
    changesTruncated
    ttl
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetChangeAuditQueryVariables,
  APITypes.GetChangeAuditQuery
>;
export const listChangeAudits = /* GraphQL */ `query ListChangeAudits(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelChangeAuditFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listChangeAudits(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      portalID
      entityType
      entityId
      operation
      channel
      actorId
      changedFields
      changes
      changesTruncated
      ttl
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListChangeAuditsQueryVariables,
  APITypes.ListChangeAuditsQuery
>;
export const listChangeAuditsByOrg = /* GraphQL */ `query ListChangeAuditsByOrg(
  $organizationID: ID
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelChangeAuditFilterInput
  $limit: Int
  $nextToken: String
) {
  listChangeAuditsByOrg(
    organizationID: $organizationID
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      portalID
      entityType
      entityId
      operation
      channel
      actorId
      changedFields
      changes
      changesTruncated
      ttl
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListChangeAuditsByOrgQueryVariables,
  APITypes.ListChangeAuditsByOrgQuery
>;
export const listChangeAuditsByEntity = /* GraphQL */ `query ListChangeAuditsByEntity(
  $entityId: ID
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelChangeAuditFilterInput
  $limit: Int
  $nextToken: String
) {
  listChangeAuditsByEntity(
    entityId: $entityId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      portalID
      entityType
      entityId
      operation
      channel
      actorId
      changedFields
      changes
      changesTruncated
      ttl
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListChangeAuditsByEntityQueryVariables,
  APITypes.ListChangeAuditsByEntityQuery
>;
export const getUser = /* GraphQL */ `query GetUser($id: ID!) {
  getUser(id: $id) {
    id
    createdAt
    updatedAt
    name
    biography
    profileImage
    email
    background
    headline
    title
    enableAdminAgent
    Organizations {
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<APITypes.GetUserQueryVariables, APITypes.GetUserQuery>;
export const listUsers = /* GraphQL */ `query ListUsers(
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      createdAt
      updatedAt
      name
      biography
      profileImage
      email
      background
      headline
      title
      enableAdminAgent
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListUsersQueryVariables, APITypes.ListUsersQuery>;
export const userByEmail = /* GraphQL */ `query UserByEmail(
  $email: String
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  userByEmail(
    email: $email
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      createdAt
      updatedAt
      name
      biography
      profileImage
      email
      background
      headline
      title
      enableAdminAgent
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserByEmailQueryVariables,
  APITypes.UserByEmailQuery
>;
export const getUserOrganization = /* GraphQL */ `query GetUserOrganization($organizationID: ID!, $id: ID!) {
  getUserOrganization(organizationID: $organizationID, id: $id) {
    id
    userID
    organizationID
    name
    superUser
    roles
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserOrganizationQueryVariables,
  APITypes.GetUserOrganizationQuery
>;
export const listUserOrganizations = /* GraphQL */ `query ListUserOrganizations(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelUserOrganizationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listUserOrganizations(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      userID
      organizationID
      name
      superUser
      roles
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserOrganizationsQueryVariables,
  APITypes.ListUserOrganizationsQuery
>;
export const getPortalKicker = /* GraphQL */ `query GetPortalKicker($organizationID: ID!, $id: ID!) {
  getPortalKicker(organizationID: $organizationID, id: $id) {
    id
    organizationID
    name
    assetID
    link
    openInNewTab
    createdAt
    updatedAt
    endAt
    tags
    text1
    text2
    text3
    text4
    text5
    richText1
    richText2
    richText3
    richText4
    richText5
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPortalKickerQueryVariables,
  APITypes.GetPortalKickerQuery
>;
export const listPortalKickers = /* GraphQL */ `query ListPortalKickers(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelPortalKickerFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listPortalKickers(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      name
      assetID
      link
      openInNewTab
      createdAt
      updatedAt
      endAt
      tags
      text1
      text2
      text3
      text4
      text5
      richText1
      richText2
      richText3
      richText4
      richText5
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPortalKickersQueryVariables,
  APITypes.ListPortalKickersQuery
>;
export const search = /* GraphQL */ `query Search($input: SearchInput!) {
  search(input: $input) {
    items
    total
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.SearchQueryVariables, APITypes.SearchQuery>;
export const commerceSearch = /* GraphQL */ `query CommerceSearch($input: CommerceSearchInput!) {
  commerceSearch(input: $input) {
    formattedText
    references
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CommerceSearchQueryVariables,
  APITypes.CommerceSearchQuery
>;
export const findBySlug = /* GraphQL */ `query FindBySlug(
  $organizationID: ID!
  $objectType: ObjectType!
  $slug: String!
  $libraryIds: [String!]
) {
  findBySlug(
    organizationID: $organizationID
    objectType: $objectType
    slug: $slug
    libraryIds: $libraryIds
  )
}
` as GeneratedQuery<
  APITypes.FindBySlugQueryVariables,
  APITypes.FindBySlugQuery
>;
export const getSignedCertificateUrl = /* GraphQL */ `query GetSignedCertificateUrl($organizationID: ID!, $certificateID: ID!) {
  getSignedCertificateUrl(
    organizationID: $organizationID
    certificateID: $certificateID
  ) {
    statusCode
    url
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSignedCertificateUrlQueryVariables,
  APITypes.GetSignedCertificateUrlQuery
>;
export const invokeAgent = /* GraphQL */ `query InvokeAgent(
  $organizationID: ID!
  $portalID: ID!
  $sessionID: String
  $prompt: String!
  $options: AWSJSON
  $adminOptions: AWSJSON
) {
  invokeAgent(
    organizationID: $organizationID
    portalID: $portalID
    sessionID: $sessionID
    prompt: $prompt
    options: $options
    adminOptions: $adminOptions
  )
}
` as GeneratedQuery<
  APITypes.InvokeAgentQueryVariables,
  APITypes.InvokeAgentQuery
>;
export const getAgentSession = /* GraphQL */ `query GetAgentSession(
  $organizationID: ID!
  $portalID: ID!
  $sessionID: String
) {
  getAgentSession(
    organizationID: $organizationID
    portalID: $portalID
    sessionID: $sessionID
  )
}
` as GeneratedQuery<
  APITypes.GetAgentSessionQueryVariables,
  APITypes.GetAgentSessionQuery
>;
export const getConfig = /* GraphQL */ `query GetConfig {
  getConfig {
    clientAiDistributionDomain
    clientAiApiEndpoint
    __typename
  }
}
` as GeneratedQuery<APITypes.GetConfigQueryVariables, APITypes.GetConfigQuery>;
export const getPageVersion = /* GraphQL */ `query GetPageVersion($organizationID: ID!, $id: ID!) {
  getPageVersion(organizationID: $organizationID, id: $id) {
    id
    organizationID
    portalID
    guideId
    versionNumber
    snapshot
    snapshotS3Key
    checksum
    authorType
    authorId
    sourceType
    taskId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPageVersionQueryVariables,
  APITypes.GetPageVersionQuery
>;
export const listPageVersions = /* GraphQL */ `query ListPageVersions(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelPageVersionFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listPageVersions(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      portalID
      guideId
      versionNumber
      snapshot
      snapshotS3Key
      checksum
      authorType
      authorId
      sourceType
      taskId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPageVersionsQueryVariables,
  APITypes.ListPageVersionsQuery
>;
export const listPageVersionsByGuide = /* GraphQL */ `query ListPageVersionsByGuide(
  $guideId: ID
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPageVersionFilterInput
  $limit: Int
  $nextToken: String
) {
  listPageVersionsByGuide(
    guideId: $guideId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      portalID
      guideId
      versionNumber
      snapshot
      snapshotS3Key
      checksum
      authorType
      authorId
      sourceType
      taskId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPageVersionsByGuideQueryVariables,
  APITypes.ListPageVersionsByGuideQuery
>;
export const getCycle = /* GraphQL */ `query GetCycle($organizationID: ID!, $id: ID!) {
  getCycle(organizationID: $organizationID, id: $id) {
    id
    organizationID
    portalID
    cycleNumber
    name
    description
    status
    phase
    startedAt
    closedAt
    plannedApprovalAt
    plannedShipAt
    maintenanceRanAt
    baselineSnapshot
    measureSnapshot
    merchantInputDraft
    merchantInputSubmission
    activeChangeSetId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetCycleQueryVariables, APITypes.GetCycleQuery>;
export const listCycles = /* GraphQL */ `query ListCycles(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelCycleFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCycles(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      portalID
      cycleNumber
      name
      description
      status
      phase
      startedAt
      closedAt
      plannedApprovalAt
      plannedShipAt
      maintenanceRanAt
      baselineSnapshot
      measureSnapshot
      merchantInputDraft
      merchantInputSubmission
      activeChangeSetId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCyclesQueryVariables,
  APITypes.ListCyclesQuery
>;
export const listCyclesByOrgStatus = /* GraphQL */ `query ListCyclesByOrgStatus(
  $organizationID: ID
  $status: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCycleFilterInput
  $limit: Int
  $nextToken: String
) {
  listCyclesByOrgStatus(
    organizationID: $organizationID
    status: $status
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      portalID
      cycleNumber
      name
      description
      status
      phase
      startedAt
      closedAt
      plannedApprovalAt
      plannedShipAt
      maintenanceRanAt
      baselineSnapshot
      measureSnapshot
      merchantInputDraft
      merchantInputSubmission
      activeChangeSetId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCyclesByOrgStatusQueryVariables,
  APITypes.ListCyclesByOrgStatusQuery
>;
export const getRecommendation = /* GraphQL */ `query GetRecommendation($organizationID: ID!, $id: ID!) {
  getRecommendation(organizationID: $organizationID, id: $id) {
    id
    organizationID
    portalID
    cycleId
    kind
    status
    text
    payload
    source
    dedupeKey
    order
    committedEntityId
    appliedChangeSetItemId
    originCycleId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRecommendationQueryVariables,
  APITypes.GetRecommendationQuery
>;
export const listRecommendations = /* GraphQL */ `query ListRecommendations(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelRecommendationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listRecommendations(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      portalID
      cycleId
      kind
      status
      text
      payload
      source
      dedupeKey
      order
      committedEntityId
      appliedChangeSetItemId
      originCycleId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRecommendationsQueryVariables,
  APITypes.ListRecommendationsQuery
>;
export const listRecommendationsByCycleStatus = /* GraphQL */ `query ListRecommendationsByCycleStatus(
  $cycleId: ID
  $status: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelRecommendationFilterInput
  $limit: Int
  $nextToken: String
) {
  listRecommendationsByCycleStatus(
    cycleId: $cycleId
    status: $status
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      portalID
      cycleId
      kind
      status
      text
      payload
      source
      dedupeKey
      order
      committedEntityId
      appliedChangeSetItemId
      originCycleId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRecommendationsByCycleStatusQueryVariables,
  APITypes.ListRecommendationsByCycleStatusQuery
>;
export const listRecommendationsByOrgPortal = /* GraphQL */ `query ListRecommendationsByOrgPortal(
  $organizationID: ID
  $portalID: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelRecommendationFilterInput
  $limit: Int
  $nextToken: String
) {
  listRecommendationsByOrgPortal(
    organizationID: $organizationID
    portalID: $portalID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      portalID
      cycleId
      kind
      status
      text
      payload
      source
      dedupeKey
      order
      committedEntityId
      appliedChangeSetItemId
      originCycleId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRecommendationsByOrgPortalQueryVariables,
  APITypes.ListRecommendationsByOrgPortalQuery
>;
export const listRecommendationsByDedupeKey = /* GraphQL */ `query ListRecommendationsByDedupeKey(
  $organizationID: ID
  $dedupeKey: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelRecommendationFilterInput
  $limit: Int
  $nextToken: String
) {
  listRecommendationsByDedupeKey(
    organizationID: $organizationID
    dedupeKey: $dedupeKey
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      portalID
      cycleId
      kind
      status
      text
      payload
      source
      dedupeKey
      order
      committedEntityId
      appliedChangeSetItemId
      originCycleId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRecommendationsByDedupeKeyQueryVariables,
  APITypes.ListRecommendationsByDedupeKeyQuery
>;
export const getChangeSet = /* GraphQL */ `query GetChangeSet($organizationID: ID!, $id: ID!) {
  getChangeSet(organizationID: $organizationID, id: $id) {
    id
    organizationID
    portalID
    title
    status
    itemCount
    createdBy
    submittedForApprovalAt
    submittedForApprovalBy
    approvedAt
    approvedBy
    rejectedAt
    rejectedBy
    rejectionNote
    publishedAt
    publishedBy
    kind
    previousChangeSetId
    supersededByChangeSetId
    lockedAt
    cycleId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetChangeSetQueryVariables,
  APITypes.GetChangeSetQuery
>;
export const listChangeSets = /* GraphQL */ `query ListChangeSets(
  $organizationID: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelChangeSetFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listChangeSets(
    organizationID: $organizationID
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      organizationID
      portalID
      title
      status
      itemCount
      createdBy
      submittedForApprovalAt
      submittedForApprovalBy
      approvedAt
      approvedBy
      rejectedAt
      rejectedBy
      rejectionNote
      publishedAt
      publishedBy
      kind
      previousChangeSetId
      supersededByChangeSetId
      lockedAt
      cycleId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListChangeSetsQueryVariables,
  APITypes.ListChangeSetsQuery
>;
export const listChangeSetsByOrgStatus = /* GraphQL */ `query ListChangeSetsByOrgStatus(
  $organizationID: ID
  $status: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelChangeSetFilterInput
  $limit: Int
  $nextToken: String
) {
  listChangeSetsByOrgStatus(
    organizationID: $organizationID
    status: $status
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      organizationID
      portalID
      title
      status
      itemCount
      createdBy
      submittedForApprovalAt
      submittedForApprovalBy
      approvedAt
      approvedBy
      rejectedAt
      rejectedBy
      rejectionNote
      publishedAt
      publishedBy
      kind
      previousChangeSetId
      supersededByChangeSetId
      lockedAt
      cycleId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListChangeSetsByOrgStatusQueryVariables,
  APITypes.ListChangeSetsByOrgStatusQuery
>;
export const getChangeSetItem = /* GraphQL */ `query GetChangeSetItem($changeSetId: ID!, $id: ID!) {
  getChangeSetItem(changeSetId: $changeSetId, id: $id) {
    id
    changeSetId
    organizationID
    portalID
    entityType
    entityId
    newVersionId
    newVersionNumber
    previousVersionId
    previousVersionNumber
    fromVersionId
    fromVersionNumber
    operation
    diffSummary
    itemStatus
    reviewNote
    reviewedAt
    reviewedBy
    changeKind
    publishAttemptAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetChangeSetItemQueryVariables,
  APITypes.GetChangeSetItemQuery
>;
export const listChangeSetItems = /* GraphQL */ `query ListChangeSetItems(
  $changeSetId: ID
  $id: ModelIDKeyConditionInput
  $filter: ModelChangeSetItemFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listChangeSetItems(
    changeSetId: $changeSetId
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      changeSetId
      organizationID
      portalID
      entityType
      entityId
      newVersionId
      newVersionNumber
      previousVersionId
      previousVersionNumber
      fromVersionId
      fromVersionNumber
      operation
      diffSummary
      itemStatus
      reviewNote
      reviewedAt
      reviewedBy
      changeKind
      publishAttemptAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListChangeSetItemsQueryVariables,
  APITypes.ListChangeSetItemsQuery
>;
export const listChangeSetItemsByChangeSet = /* GraphQL */ `query ListChangeSetItemsByChangeSet(
  $changeSetId: ID
  $entityId: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelChangeSetItemFilterInput
  $limit: Int
  $nextToken: String
) {
  listChangeSetItemsByChangeSet(
    changeSetId: $changeSetId
    entityId: $entityId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      changeSetId
      organizationID
      portalID
      entityType
      entityId
      newVersionId
      newVersionNumber
      previousVersionId
      previousVersionNumber
      fromVersionId
      fromVersionNumber
      operation
      diffSummary
      itemStatus
      reviewNote
      reviewedAt
      reviewedBy
      changeKind
      publishAttemptAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListChangeSetItemsByChangeSetQueryVariables,
  APITypes.ListChangeSetItemsByChangeSetQuery
>;
export const listChangeSetItemsByEntity = /* GraphQL */ `query ListChangeSetItemsByEntity(
  $organizationID: ID
  $entityId: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelChangeSetItemFilterInput
  $limit: Int
  $nextToken: String
) {
  listChangeSetItemsByEntity(
    organizationID: $organizationID
    entityId: $entityId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      changeSetId
      organizationID
      portalID
      entityType
      entityId
      newVersionId
      newVersionNumber
      previousVersionId
      previousVersionNumber
      fromVersionId
      fromVersionNumber
      operation
      diffSummary
      itemStatus
      reviewNote
      reviewedAt
      reviewedBy
      changeKind
      publishAttemptAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListChangeSetItemsByEntityQueryVariables,
  APITypes.ListChangeSetItemsByEntityQuery
>;
